/* Source: /home/ubuntu/libredraw/frontend/editor/EditorShell.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { PanelLeftOpen, PanelRightOpen, Trash2, FileText, Sparkles, Heart, X } from "lucide-react";
import { jacLogout, jacIsLoggedIn, jacLogin, jacSignup, useNavigate } from "@jac/runtime";
import { cn } from "../../lib/utils.js";
import { __jacCallFunction } from "@jac/runtime";
import { createCollab, makeCollaborator, myIdentities } from "./collab.tsx";
import { ShareDialog } from "./ShareDialog.js";
import { AuthModal } from "./AuthModal.js";
import { TopBar } from "./TopBar.js";
import { DiagramTabs } from "./DiagramTabs.js";
import { LeftPanel } from "./LeftPanel.js";
import { ToolRail } from "./ToolRail.js";
import { CanvasStage } from "./canvas/CanvasStage.tsx";
import { CANVAS_GEOMETRY_MODULE } from "./canvas/geometry.ts";
import { migrateLegacyMirror } from "./legacyMirror.ts";
import { RightPanel } from "./RightPanel.js";
import { PageBar } from "./PageBar.js";
import { CommandPalette } from "./CommandPalette.js";
import { ContributeModal } from "./ContributeModal.js";
import { ShortcutsModal } from "./ShortcutsModal.js";
import { ImportModal } from "./ImportModal.js";
import { FindPanel } from "./FindPanel.js";
import { TemplatePicker } from "./TemplatePicker.js";
import { openSupporterCheckout } from "./paddleCheckout.ts";
import { useState } from "@jac/runtime";
import { useRef } from "react";
import { useEffect } from "@jac/runtime";
async function LoadDoc() {
  return await __jacCallFunction("LoadDoc", {});
}
async function SavePage() {
  return await __jacCallFunction("SavePage", {});
}
async function DeletePage() {
  return await __jacCallFunction("DeletePage", {});
}
async function ReorderPages() {
  return await __jacCallFunction("ReorderPages", {});
}
async function SaveComments() {
  return await __jacCallFunction("SaveComments", {});
}
async function LoadLibraries() {
  return await __jacCallFunction("LoadLibraries", {});
}
async function SaveLibrary() {
  return await __jacCallFunction("SaveLibrary", {});
}
async function DeleteLibrary() {
  return await __jacCallFunction("DeleteLibrary", {});
}
async function CreateShare() {
  return await __jacCallFunction("CreateShare", {});
}
async function OpenShare() {
  return await __jacCallFunction("OpenShare", {});
}
async function SaveShare() {
  return await __jacCallFunction("SaveShare", {});
}
async function SetShareAccess() {
  return await __jacCallFunction("SetShareAccess", {});
}
async function StopSharing() {
  return await __jacCallFunction("StopSharing", {});
}
async function AcceptInvite() {
  return await __jacCallFunction("AcceptInvite", {});
}
async function DiagramShareId() {
  return await __jacCallFunction("DiagramShareId", {});
}
async function RenameDiagram() {
  return await __jacCallFunction("RenameDiagram", {});
}
async function ListTrash() {
  return await __jacCallFunction("ListTrash", {});
}
async function RestorePage() {
  return await __jacCallFunction("RestorePage", {});
}
async function PurgePage() {
  return await __jacCallFunction("PurgePage", {});
}
async function ConnectedShapes() {
  return await __jacCallFunction("ConnectedShapes", {});
}
async function ListSnapshots() {
  return await __jacCallFunction("ListSnapshots", {});
}
async function GetSnapshot() {
  return await __jacCallFunction("GetSnapshot", {});
}
async function RestoreSnapshot() {
  return await __jacCallFunction("RestoreSnapshot", {});
}
async function DiagramFolderPath() {
  return await __jacCallFunction("DiagramFolderPath", {});
}
async function PaddleConfig() {
  return await __jacCallFunction("PaddleConfig", {});
}
async function MySubscription() {
  return await __jacCallFunction("MySubscription", {});
}
async function CustomerPortal() {
  return await __jacCallFunction("CustomerPortal", {});
}
const _jac = {
  int: {
    bit_length(n) {
      if (n === 0) return 0;
      return Math.floor(Math.log2(Math.abs(n))) + 1;
    },
    bit_count(n) {
      let x = Math.abs(n);
      let count = 0;
      while (x) { count += x & 1; x >>= 1; }
      return count;
    },
    to_bytes(n, length, byteorder) {
      const bytes = [];
      let val = n < 0 ? (1 << (length * 8)) + n : n;
      for (let i = 0; i < length; i++) {
        bytes.push(val & 0xff);
        val >>= 8;
      }
      if (byteorder === "big") bytes.reverse();
      return bytes;
    },
    from_bytes(bytes, byteorder) {
      const b = byteorder === "big" ? bytes : [...bytes].reverse();
      let result = 0;
      for (const byte of b) result = (result << 8) | byte;
      return result;
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  float: {
    as_integer_ratio(f) {
      if (!isFinite(f)) throw new _jac.exc.ValueError("cannot convert " + f + " to integer ratio");
      if (f === 0) return [0, 1];
      let num = f, den = 1;
      while (num !== Math.floor(num)) { num *= 2; den *= 2; }
      const g = _jac.float._gcd(Math.abs(num), den);
      return [num / g, den / g];
    },
    _gcd(a, b) { while (b) { [a, b] = [b, a % b]; } return a; },
    hex(f) {
      return f.toString(16);
    },
    fromhex(s) {
      return parseFloat(s);
    },
    mod(a, b) { return ((a % b) + b) % b; }
  },

  complex: {
    conjugate(c) { return {re: c.re, im: -c.im}; },
    add(a, b) { return {re: a.re + b.re, im: a.im + b.im}; },
    sub(a, b) { return {re: a.re - b.re, im: a.im - b.im}; },
    mul(a, b) { return {re: a.re * b.re - a.im * b.im, im: a.re * b.im + a.im * b.re}; },
    truediv(a, b) {
      const d = b.re * b.re + b.im * b.im;
      return {re: (a.re * b.re + a.im * b.im) / d, im: (a.im * b.re - a.re * b.im) / d};
    },
    pow(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      if (b.im === 0 && Number.isInteger(b.re)) {
        let result = {re: 1, im: 0};
        for (let i = 0; i < Math.abs(b.re); i++) result = _jac.complex.mul(result, a);
        return b.re < 0 ? _jac.complex.truediv({re: 1, im: 0}, result) : result;
      }
      const r = Math.sqrt(a.re * a.re + a.im * a.im);
      const theta = Math.atan2(a.im, a.re);
      const lnr = Math.log(r);
      const newR = Math.exp(lnr * b.re - theta * b.im);
      const newTheta = lnr * b.im + theta * b.re;
      return {re: newR * Math.cos(newTheta), im: newR * Math.sin(newTheta)};
    },
    eq(a, b) {
      if (typeof b === "number") b = {re: b, im: 0};
      if (typeof a === "number") a = {re: a, im: 0};
      return a.re === b.re && a.im === b.im;
    },
    neg(a) { return {re: -a.re, im: -a.im}; },
    pos(a) { return {re: +a.re, im: +a.im}; }
  },

  str: {
    capitalize(s) {
      if (s.length === 0) return s;
      return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    },
    title(s) {
      return s.replace(/\b\w/g, c => c.toUpperCase());
    },
    swapcase(s) {
      return [...s].map(c => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase()).join("");
    },
    count(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      if (sub === "") return t.length + 1;
      let count = 0, pos = 0;
      while ((pos = t.indexOf(sub, pos)) !== -1) { count++; pos += sub.length; }
      return count;
    },
    find(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.indexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    rfind(s, sub, start, end) {
      const t = s.slice(start || 0, end);
      const idx = t.lastIndexOf(sub);
      return idx === -1 ? -1 : idx + (start || 0);
    },
    index(s, sub, start, end) {
      const idx = _jac.str.find(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(s, sub, start, end) {
      const idx = _jac.str.rfind(s, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(s, prefix, start, end) {
      return s.slice(start || 0, end).startsWith(prefix);
    },
    endswith(s, suffix, start, end) {
      return s.slice(start || 0, end).endsWith(suffix);
    },
    replace(s, old, new_, count) {
      if (count === undefined) return s.split(old).join(new_);
      let result = s, n = 0;
      while (n < count) {
        const idx = result.indexOf(old);
        if (idx === -1) break;
        result = result.slice(0, idx) + new_ + result.slice(idx + old.length);
        n++;
      }
      return result;
    },
    strip(s, chars) {
      if (!chars) return s.trim();
      let start = 0, end = s.length;
      while (start < end && chars.indexOf(s[start]) !== -1) start++;
      while (end > start && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(start, end);
    },
    lstrip(s, chars) {
      if (!chars) return s.trimStart();
      let start = 0;
      while (start < s.length && chars.indexOf(s[start]) !== -1) start++;
      return s.slice(start);
    },
    rstrip(s, chars) {
      if (!chars) return s.trimEnd();
      let end = s.length;
      while (end > 0 && chars.indexOf(s[end - 1]) !== -1) end--;
      return s.slice(0, end);
    },
    removeprefix(s, prefix) {
      return s.startsWith(prefix) ? s.slice(prefix.length) : s;
    },
    removesuffix(s, suffix) {
      return (suffix && s.endsWith(suffix)) ? s.slice(0, -suffix.length) : s;
    },
    split(s, sep, maxsplit) {
      if (sep === undefined || sep === null) {
        const parts = s.trim().split(/\s+/);
        if (maxsplit === undefined) return parts;
        if (maxsplit <= 0) return [s];
        return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(" ")].filter(x => x !== undefined);
      }
      if (maxsplit === undefined) return s.split(sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      return [...parts.slice(0, maxsplit), parts.slice(maxsplit).join(sep)];
    },
    rsplit(s, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.str.split(s, sep);
      const parts = s.split(sep);
      if (parts.length <= maxsplit + 1) return parts;
      const keep = parts.length - maxsplit;
      return [parts.slice(0, keep).join(sep), ...parts.slice(keep)];
    },
    splitlines(s, keepends) {
      const lines = s.split(/(\r\n|\r|\n)/);
      const result = [];
      for (let i = 0; i < lines.length; i += 2) {
        const line = lines[i];
        const sep = lines[i + 1] || "";
        if (line || sep) result.push(keepends ? line + sep : line);
      }
      return result;
    },
    partition(s, sep) {
      const idx = s.indexOf(sep);
      if (idx === -1) return [s, "", ""];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    rpartition(s, sep) {
      const idx = s.lastIndexOf(sep);
      if (idx === -1) return ["", "", s];
      return [s.slice(0, idx), sep, s.slice(idx + sep.length)];
    },
    format(s, ...args) {
      let i = 0;
      return s.replace(/\{(\w*)\}/g, (match, key) => {
        if (key === "") return args[i++];
        if (!isNaN(key)) return args[parseInt(key)];
        return args[0] && typeof args[0] === "object" ? args[0][key] : match;
      });
    },
    format_map(s, mapping) {
      return s.replace(/\{(\w+)\}/g, (match, key) => key in mapping ? mapping[key] : match);
    },
    center(s, width, fillchar) {
      const fc = fillchar || " ";
      if (s.length >= width) return s;
      const total = width - s.length;
      const left = Math.floor(total / 2);
      return fc.repeat(left) + s + fc.repeat(total - left);
    },
    zfill(s, width) {
      if (s.length >= width) return s;
      const sign = (s[0] === "+" || s[0] === "-") ? s[0] : "";
      const body = sign ? s.slice(1) : s;
      return sign + "0".repeat(width - s.length) + body;
    },
    expandtabs(s, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      let result = "", col = 0;
      for (const c of s) {
        if (c === "\t") { const sp = ts - (col % ts); result += " ".repeat(sp); col += sp; }
        else if (c === "\n" || c === "\r") { result += c; col = 0; }
        else { result += c; col++; }
      }
      return result;
    },
    isnumeric(s) {
      if (s.length === 0) return false;
      return [...s].every(c => /[\d\u00B2\u00B3\u00B9\u00BC-\u00BE\u2150-\u218F]/.test(c));
    },
    istitle(s) {
      return s === _jac.str.title(s) && /[A-Za-z]/.test(s);
    },
    translate(s, table) {
      return [...s].map(c => {
        const code = c.charCodeAt(0);
        if (code in table) {
          const v = table[code];
          if (v === null) return "";
          if (typeof v === "number") return String.fromCharCode(v);
          return v;
        }
        return c;
      }).join("");
    },
    maketrans(...args) {
      const table = {};
      if (args.length === 1) {
        const mapping = args[0];
        for (const [k, v] of Object.entries(mapping)) {
          table[typeof k === "string" ? k.charCodeAt(0) : k] = v;
        }
      } else if (args.length >= 2) {
        const from_ = args[0], to_ = args[1];
        for (let i = 0; i < from_.length; i++) {
          table[from_.charCodeAt(i)] = to_.charCodeAt(i);
        }
        if (args[2]) {
          for (const c of args[2]) table[c.charCodeAt(0)] = null;
        }
      }
      return table;
    },
    mod(s, args) {
      let i = 0;
      const a = Array.isArray(args) ? args : [args];
      return s.replace(/%([sd%])/g, (m, fmt) => {
        if (fmt === "%") return "%";
        return String(a[i++]);
      });
    }
  },

  // Runtime-polymorphic method dispatch, used when the codegen cannot prove
  // the static type of a method-call receiver (e.g. a `dict`-typed prop, the
  // result of `or` widening, or a comprehension over an untyped value) and so
  // cannot pick a typed emitter. The compiler emits
  // `_jac.poly.call(obj, "name", ...args)`; `call` resolves the *runtime* type
  // of `obj` and applies the matching Python operation, forwards to a
  // same-named method on a user-defined object, or raises AttributeError. The
  // per-type tables below carry the trivial native-mapped methods inline and
  // delegate the non-trivial ones to the shared `_jac.str/list/dict/set`
  // helpers, so each operation has a single implementation and no Python
  // method name can leak verbatim into the emitted JavaScript.
  poly: {
    _typename(o) {
      if (o === null || o === undefined) return "NoneType";
      if (Array.isArray(o)) return "list";
      if (o instanceof Set) return "set";
      if (o instanceof Map) return "dict";
      if (o instanceof Uint8Array) return "bytes";
      const t = typeof o;
      if (t === "string") return "str";
      if (t === "boolean") return "bool";
      if (t === "number") return Number.isInteger(o) ? "int" : "float";
      if (t === "object") return (o.constructor && o.constructor.name) || "object";
      return t;
    },
    // --- per-runtime-type Python method tables (keyed by Python name) ---
    // Trivial native-mapped ops are inline; non-trivial ones delegate to the
    // shared `_jac.<type>` helpers (which the typed emitters also use), so the
    // typed and polymorphic paths share one implementation.
    _str: {
      lower: (s) => s.toLowerCase(),
      upper: (s) => s.toUpperCase(),
      casefold: (s) => s.toLowerCase(),
      strip: (s, chars) => {
        if (chars === undefined) return s.trim();
        let i = 0, j = s.length;
        while (i < j && chars.indexOf(s[i]) !== -1) i++;
        while (j > i && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(i, j);
      },
      lstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/^\s+/, "");
        let i = 0;
        while (i < s.length && chars.indexOf(s[i]) !== -1) i++;
        return s.slice(i);
      },
      rstrip: (s, chars) => {
        if (chars === undefined) return s.replace(/\s+$/, "");
        let j = s.length;
        while (j > 0 && chars.indexOf(s[j - 1]) !== -1) j--;
        return s.slice(0, j);
      },
      join: (s, parts) => Array.from(parts, x => String(x)).join(s)
    },
    _list: {
      append: (a, x) => { a.push(x); return null; },
      clear: (a) => { a.length = 0; return null; },
      copy: (a) => a.slice(),
      count: (a, x) => _jac.list.count(a, x),
      extend: (a, b) => { for (const v of b) a.push(v); return null; },
      index: (a, x, start, end) => _jac.list.index(a, x, start, end),
      insert: (a, i, x) => { a.splice(i, 0, x); return null; },
      pop: (a, i) => {
        if (i === undefined) return a.pop();
        const idx = i < 0 ? a.length + i : i;
        return a.splice(idx, 1)[0];
      },
      remove: (a, x) => _jac.list.remove(a, x),
      reverse: (a) => { a.reverse(); return null; },
      sort: (a, key) => _jac.list.sort(a, key)
    },
    _dict: {
      clear: (o) => _jac.dict.clear(o),
      copy: (o) => ({ ...o }),
      // Python `dict.get`: returns the stored value when the key is present
      // (even if it is null), and the default only when the key is absent.
      // A membership check is required — `o[key] ?? default_` would wrongly
      // substitute the default for a present-but-null value.
      get: (o, key, default_) =>
        Object.prototype.hasOwnProperty.call(o, key) ? o[key] : default_,
      items: (o) => Object.entries(o),
      keys: (o) => Object.keys(o),
      pop: (o, key, default_) => _jac.dict.pop(o, key, default_),
      popitem: (o) => _jac.dict.popitem(o),
      setdefault: (o, key, default_) => _jac.dict.setdefault(o, key, default_),
      update: (o, other) => {
        if (other instanceof Map) { for (const [k, v] of other) o[k] = v; }
        else if (Array.isArray(other)) { for (const [k, v] of other) o[k] = v; }
        else if (other) { for (const k of Object.keys(other)) o[k] = other[k]; }
        return null;
      },
      values: (o) => Object.values(o)
    },
    _set: {
      add: (s, x) => { s.add(x); return null; },
      clear: (s) => { s.clear(); return null; },
      copy: (s) => new Set(s),
      difference: (a, b) => _jac.set.difference(a, b),
      difference_update: (s, o) => _jac.set.difference_update(s, o),
      discard: (s, x) => { s.delete(x); return null; },
      intersection: (a, b) => _jac.set.intersection(a, b),
      intersection_update: (s, o) => _jac.set.intersection_update(s, o),
      isdisjoint: (a, b) => _jac.set.isDisjointFrom(a, b instanceof Set ? b : new Set(b)),
      issubset: (a, b) => _jac.set.isSubsetOf(a, b instanceof Set ? b : new Set(b)),
      issuperset: (a, b) => _jac.set.isSupersetOf(a, b instanceof Set ? b : new Set(b)),
      pop: (s) => _jac.set.pop(s),
      remove: (s, x) => _jac.set.remove(s, x),
      symmetric_difference: (a, b) => _jac.set.symmetricDifference(a, b),
      symmetric_difference_update: (s, o) => _jac.set.symmetric_difference_update(s, o),
      union: (a, b) => _jac.set.union(a, b),
      update: (s, o) => _jac.set.update(s, o)
    },
    // Jac dicts compile to plain objects, but interop code may hand us a real
    // Map; mirror the dict methods over the Map API for that case.
    _map: {
      clear: (m) => { m.clear(); return null; },
      copy: (m) => new Map(m),
      get: (m, key, default_) => (m.has(key) ? m.get(key) : default_),
      items: (m) => [...m.entries()],
      keys: (m) => [...m.keys()],
      pop: (m, key, default_) => {
        if (m.has(key)) { const v = m.get(key); m.delete(key); return v; }
        if (default_ !== undefined) return default_;
        throw new _jac.exc.KeyError("KeyError: " + key);
      },
      popitem: (m) => {
        if (m.size === 0) throw new _jac.exc.KeyError("dictionary is empty");
        const key = [...m.keys()].pop();
        const val = m.get(key);
        m.delete(key);
        return [key, val];
      },
      setdefault: (m, key, default_) => {
        if (!m.has(key)) m.set(key, default_ === undefined ? null : default_);
        return m.get(key);
      },
      update: (m, other) => {
        if (other instanceof Map) { for (const [k, v] of other) m.set(k, v); }
        else if (Array.isArray(other)) { for (const [k, v] of other) m.set(k, v); }
        else if (other) { for (const k of Object.keys(other)) m.set(k, other[k]); }
        return null;
      },
      values: (m) => [...m.values()]
    },
    // Single entry point. `obj.method(...args)` on a receiver whose static
    // type is not provably primitive is compiled to
    // `_jac.poly.call(obj, "method", ...args)`.
    call(o, m, ...args) {
      // 1. Genuine JS primitives get Python-semantic dispatch: a plain object
      //    is a Python dict, an Array is a list, a Set/Map/string/number/bytes
      //    maps to its Python counterpart. These are the types whose Python
      //    method semantics differ from (or have no) native JS equivalent.
      if (typeof o === "string") {
        if (_jac.poly._str[m]) return _jac.poly._str[m](o, ...args);
        if (_jac.str[m]) return _jac.str[m](o, ...args);
      } else if (typeof o === "number") {
        const ns = Number.isInteger(o) ? _jac.int : _jac.float;
        if (ns && ns[m]) return ns[m](o, ...args);
      } else if (Array.isArray(o)) {
        if (_jac.poly._list[m]) return _jac.poly._list[m](o, ...args);
      } else if (o instanceof Set) {
        if (_jac.poly._set[m]) return _jac.poly._set[m](o, ...args);
      } else if (o instanceof Map) {
        if (_jac.poly._map[m]) return _jac.poly._map[m](o, ...args);
      } else if (o instanceof Uint8Array) {
        if (_jac.bytes[m]) return _jac.bytes[m](o, ...args);
      } else if (
        o !== null && o !== undefined && typeof o === "object"
        && (Object.getPrototypeOf(o) === Object.prototype
            || Object.getPrototypeOf(o) === null)
      ) {
        // A plain object is a Python dict literal.
        if (_jac.poly._dict[m]) return _jac.poly._dict[m](o, ...args);
      }
      // 2. Otherwise forward to a same-named method the receiver carries
      //    itself: a user-defined class instance, a host/framework object
      //    (Headers, URLSearchParams, ...), a callable with attached methods,
      //    or a Set/Map/Array method not mirrored above. This matches the
      //    direct `obj.method(...)` that a typed call would have emitted.
      if (o !== null && o !== undefined && typeof o[m] === "function") {
        return o[m](...args);
      }
      // 3. Nothing applies: raise the Python-style error instead of leaking a
      //    method name or silently returning a wrong value.
      throw new _jac.exc.AttributeError(
        "'" + _jac.poly._typename(o) + "' object has no attribute '" + m + "'");
    },
    // Backward-compatible named shims. The compiler now emits `call`, but a
    // previously-built bundle may still reference a named helper; these route
    // it through the same dispatcher (rest params preserve the arg count).
    lower(s, ...r) { return _jac.poly.call(s, "lower", ...r); },
    upper(s, ...r) { return _jac.poly.call(s, "upper", ...r); },
    strip(s, ...r) { return _jac.poly.call(s, "strip", ...r); },
    lstrip(s, ...r) { return _jac.poly.call(s, "lstrip", ...r); },
    rstrip(s, ...r) { return _jac.poly.call(s, "rstrip", ...r); },
    append(a, ...r) { return _jac.poly.call(a, "append", ...r); },
    extend(a, ...r) { return _jac.poly.call(a, "extend", ...r); },
    pop(a, ...r) { return _jac.poly.call(a, "pop", ...r); },
    get(o, ...r) { return _jac.poly.call(o, "get", ...r); },
    contains(c, x) {
      // Python-equivalent membership for a value of unknown static type.
      // string -> substring; array (list/tuple/range) -> element;
      // Set/Map -> key/element; plain object (dict) -> own key.
      if (typeof c === "string") return c.includes(x);
      if (Array.isArray(c)) return c.includes(x);
      if (c instanceof Set || c instanceof Map) return c.has(x);
      if (c !== null && typeof c === "object") {
        return Object.prototype.hasOwnProperty.call(c, x);
      }
      return false;
    },
    getitem(c, i) {
      // Subscript read for a value of unknown static type. This is a faithful
      // superset of a raw `c[i]`: it only adds Python's negative indexing for
      // sequences (string/array) and otherwise preserves JS semantics exactly
      // (mapping/object access, out-of-range -> `undefined`, no new throws).
      if (typeof i === "number" && i < 0
          && (typeof c === "string" || Array.isArray(c))) {
        return c[c.length + i];
      }
      if (c instanceof Map) return c.get(i);
      return c[i];
    },
    setitem(c, i, v) {
      // Subscript assignment for a value of unknown/list static type. A
      // negative index writes the array element counted from the end (a raw
      // JS `c[-1] = v` would instead create a bogus "-1" property); every
      // other case behaves like a plain `c[i] = v`.
      if (typeof i === "number" && i < 0 && Array.isArray(c)) {
        c[c.length + i] = v;
        return v;
      }
      if (c instanceof Map) { c.set(i, v); return v; }
      c[i] = v;
      return v;
    },
    and_(a, bf) {
      // Python `a and b`: returns `a` when it is falsy, else evaluates and
      // returns `b`. `bf` is a thunk so the right operand keeps short-circuit
      // (lazy) evaluation, and `a` is evaluated exactly once by the caller.
      return _jac.builtin.bool(a) ? bf() : a;
    },
    or_(a, bf) {
      // Python `a or b`: returns `a` when it is truthy, else `b`.
      return _jac.builtin.bool(a) ? a : bf();
    }
  },

  list: {
    remove(arr, val) {
      const i = arr.indexOf(val);
      if (i === -1) throw new _jac.exc.ValueError("list.remove(x): x not in list");
      arr.splice(i, 1);
    },
    index(arr, val, start, end) {
      const s = start || 0;
      const e = end === undefined ? arr.length : end;
      for (let i = s; i < e; i++) {
        if (arr[i] === val) return i;
      }
      throw new _jac.exc.ValueError(val + " is not in list");
    },
    count(arr, val) {
      let c = 0;
      for (const item of arr) { if (item === val) c++; }
      return c;
    },
    sort(arr, key) {
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
    },
    repeat(arr, n) {
      const result = [];
      for (let i = 0; i < n; i++) result.push(...arr);
      return result;
    },
    eq(a, b) { return JSON.stringify(a) === JSON.stringify(b); },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.list.lt(b, a); },
    le(a, b) { return _jac.list.eq(a, b) || _jac.list.lt(a, b); },
    ge(a, b) { return _jac.list.eq(a, b) || _jac.list.gt(a, b); },
    imul(arr, n) {
      const orig = [...arr];
      arr.length = 0;
      for (let i = 0; i < n; i++) arr.push(...orig);
      return arr;
    }
  },

  dict: {
    pop(d, key, default_) {
      if (key in d) { const v = d[key]; delete d[key]; return v; }
      if (default_ !== undefined) return default_;
      throw new _jac.exc.KeyError("KeyError: " + key);
    },
    popitem(d) {
      const keys = Object.keys(d);
      if (keys.length === 0) throw new _jac.exc.KeyError("dictionary is empty");
      const key = keys[keys.length - 1];
      const val = d[key];
      delete d[key];
      return [key, val];
    },
    setdefault(d, key, default_) {
      if (!(key in d)) d[key] = default_ === undefined ? null : default_;
      return d[key];
    },
    clear(d) {
      for (const key of Object.keys(d)) delete d[key];
    },
    fromkeys(keys, value) {
      const d = {};
      const v = value === undefined ? null : value;
      for (const k of keys) d[k] = v;
      return d;
    },
    eq(a, b) {
      const ka = Object.keys(a), kb = Object.keys(b);
      if (ka.length !== kb.length) return false;
      for (const k of ka) {
        if (!(k in b)) return false;
        const va = a[k], vb = b[k];
        if (va !== vb) {
          if (typeof va === "object" && typeof vb === "object" && va !== null && vb !== null) {
            if (JSON.stringify(va) !== JSON.stringify(vb)) return false;
          } else return false;
        }
      }
      return true;
    }
  },

  set: {
    remove(s, val) {
      if (!s.has(val)) throw new _jac.exc.KeyError("KeyError: " + val);
      s.delete(val);
    },
    pop(s) {
      if (s.size === 0) throw new _jac.exc.KeyError("pop from an empty set");
      const val = s.values().next().value;
      s.delete(val);
      return val;
    },
    update(s, other) { for (const v of other) s.add(v); },
    intersection_update(s, other) {
      const otherSet = other instanceof Set ? other : new Set(other);
      for (const v of s) { if (!otherSet.has(v)) s.delete(v); }
    },
    difference_update(s, other) {
      for (const v of other) s.delete(v);
    },
    symmetric_difference_update(s, other) {
      for (const v of other) { if (s.has(v)) s.delete(v); else s.add(v); }
    },
    union(a, b) {
      const r = new Set(a);
      for (const v of b) r.add(v);
      return r;
    },
    intersection(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (bs.has(v)) r.add(v); }
      return r;
    },
    difference(a, b) {
      const bs = b instanceof Set ? b : new Set(b);
      const r = new Set();
      for (const v of a) { if (!bs.has(v)) r.add(v); }
      return r;
    },
    symmetricDifference(a, b) {
      const r = new Set(a);
      for (const v of b) { if (r.has(v)) r.delete(v); else r.add(v); }
      return r;
    },
    isSubsetOf(a, b) {
      if (a.size > b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    isSupersetOf(a, b) { return _jac.set.isSubsetOf(b, a); },
    isDisjointFrom(a, b) {
      for (const v of a) { if (b.has(v)) return false; }
      return true;
    },
    is_proper_subset(a, b) {
      if (a.size >= b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    },
    is_proper_superset(a, b) { return _jac.set.is_proper_subset(b, a); },
    eq(a, b) {
      if (a.size !== b.size) return false;
      for (const v of a) { if (!b.has(v)) return false; }
      return true;
    }
  },

  bytes: {
    hex(b) {
      return Array.from(b).map(x => x.toString(16).padStart(2, "0")).join("");
    },
    fromhex(s) {
      const arr = [];
      const clean = s.replace(/\s/g, "");
      for (let i = 0; i < clean.length; i += 2) arr.push(parseInt(clean.substr(i, 2), 16));
      return new Uint8Array(arr);
    },
    _indexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return s;
      for (let i = s; i <= e - sl; i++) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    _lastIndexOf(b, sub, start, end) {
      const s = start || 0;
      const e = end === undefined ? b.length : end;
      const sl = sub.length;
      if (sl === 0) return e;
      for (let i = e - sl; i >= s; i--) {
        let m = true;
        for (let j = 0; j < sl; j++) { if (b[i + j] !== sub[j]) { m = false; break; } }
        if (m) return i;
      }
      return -1;
    },
    count(b, sub) {
      let c = 0, p = 0;
      while (p <= b.length - sub.length) {
        const idx = _jac.bytes._indexOf(b, sub, p);
        if (idx === -1) break;
        c++; p = idx + sub.length;
      }
      return c;
    },
    find(b, sub, start, end) { return _jac.bytes._indexOf(b, sub, start, end); },
    rfind(b, sub, start, end) { return _jac.bytes._lastIndexOf(b, sub, start, end); },
    index(b, sub, start, end) {
      const idx = _jac.bytes._indexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    rindex(b, sub, start, end) {
      const idx = _jac.bytes._lastIndexOf(b, sub, start, end);
      if (idx === -1) throw new _jac.exc.ValueError("substring not found");
      return idx;
    },
    startswith(b, prefix, start, end) {
      const s = start || 0;
      if (prefix.length > b.length - s) return false;
      for (let i = 0; i < prefix.length; i++) { if (b[s + i] !== prefix[i]) return false; }
      return true;
    },
    endswith(b, suffix, start, end) {
      const e = end === undefined ? b.length : end;
      if (suffix.length > e) return false;
      const off = e - suffix.length;
      for (let i = 0; i < suffix.length; i++) { if (b[off + i] !== suffix[i]) return false; }
      return true;
    },
    replace(b, old_, new_, count) {
      const r = [];
      let pos = 0, n = 0;
      const max = count === undefined ? Infinity : count;
      while (pos <= b.length) {
        if (n < max) {
          const idx = _jac.bytes._indexOf(b, old_, pos);
          if (idx !== -1) {
            for (let i = pos; i < idx; i++) r.push(b[i]);
            for (let i = 0; i < new_.length; i++) r.push(new_[i]);
            pos = idx + old_.length; n++;
            continue;
          }
        }
        for (let i = pos; i < b.length; i++) r.push(b[i]);
        break;
      }
      return new Uint8Array(r);
    },
    _isWS(c) { return c === 32 || c === 9 || c === 10 || c === 13 || c === 11 || c === 12; },
    strip(b, chars) {
      let s = 0, e = b.length;
      if (chars) { const cs = new Set(chars); while (s < e && cs.has(b[s])) s++; while (e > s && cs.has(b[e-1])) e--; }
      else { while (s < e && _jac.bytes._isWS(b[s])) s++; while (e > s && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(s, e);
    },
    lstrip(b, chars) {
      let s = 0;
      if (chars) { const cs = new Set(chars); while (s < b.length && cs.has(b[s])) s++; }
      else { while (s < b.length && _jac.bytes._isWS(b[s])) s++; }
      return b.slice(s);
    },
    rstrip(b, chars) {
      let e = b.length;
      if (chars) { const cs = new Set(chars); while (e > 0 && cs.has(b[e-1])) e--; }
      else { while (e > 0 && _jac.bytes._isWS(b[e-1])) e--; }
      return b.slice(0, e);
    },
    removeprefix(b, prefix) {
      if (_jac.bytes.startswith(b, prefix)) return b.slice(prefix.length);
      return b.slice();
    },
    removesuffix(b, suffix) {
      if (suffix.length > 0 && _jac.bytes.endswith(b, suffix)) return b.slice(0, b.length - suffix.length);
      return b.slice();
    },
    split(b, sep, maxsplit) {
      const parts = [];
      let pos = 0, n = 0;
      const max = maxsplit === undefined ? Infinity : maxsplit;
      while (pos <= b.length) {
        if (n >= max) { parts.push(b.slice(pos)); return parts; }
        const idx = _jac.bytes._indexOf(b, sep, pos);
        if (idx === -1) { parts.push(b.slice(pos)); return parts; }
        parts.push(b.slice(pos, idx));
        pos = idx + sep.length; n++;
      }
      if (pos <= b.length) parts.push(b.slice(pos));
      return parts;
    },
    rsplit(b, sep, maxsplit) {
      if (maxsplit === undefined) return _jac.bytes.split(b, sep);
      const parts = [];
      let end = b.length, n = 0;
      while (end >= 0 && n < maxsplit) {
        const idx = _jac.bytes._lastIndexOf(b, sep, 0, end);
        if (idx === -1) break;
        parts.unshift(b.slice(idx + sep.length, end));
        end = idx; n++;
      }
      parts.unshift(b.slice(0, end));
      return parts;
    },
    splitlines(b, keepends) {
      const result = [];
      let start = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 10 || b[i] === 13) {
          let eol = i + 1;
          if (b[i] === 13 && i + 1 < b.length && b[i + 1] === 10) eol++;
          result.push(keepends ? b.slice(start, eol) : b.slice(start, i));
          start = eol;
          if (eol > i + 1) i++;
        }
      }
      if (start < b.length) result.push(b.slice(start));
      return result;
    },
    join(sep, parts) {
      if (parts.length === 0) return new Uint8Array(0);
      const r = [];
      for (let i = 0; i < parts.length; i++) {
        if (i > 0) for (const x of sep) r.push(x);
        for (const x of parts[i]) r.push(x);
      }
      return new Uint8Array(r);
    },
    partition(b, sep) {
      const idx = _jac.bytes._indexOf(b, sep);
      if (idx === -1) return [b.slice(), new Uint8Array(0), new Uint8Array(0)];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    rpartition(b, sep) {
      const idx = _jac.bytes._lastIndexOf(b, sep);
      if (idx === -1) return [new Uint8Array(0), new Uint8Array(0), b.slice()];
      return [b.slice(0, idx), sep.slice(), b.slice(idx + sep.length)];
    },
    _isUp(c) { return c >= 65 && c <= 90; },
    _isLo(c) { return c >= 97 && c <= 122; },
    _isAl(c) { return (c >= 65 && c <= 90) || (c >= 97 && c <= 122); },
    _isDig(c) { return c >= 48 && c <= 57; },
    capitalize(b) {
      if (b.length === 0) return new Uint8Array(0);
      const r = new Uint8Array(b.length);
      r[0] = _jac.bytes._isLo(b[0]) ? b[0] - 32 : b[0];
      for (let i = 1; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    lower(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i];
      return r;
    },
    upper(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) r[i] = _jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i];
      return r;
    },
    title(b) {
      const r = new Uint8Array(b.length);
      let prev = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isAl(b[i])) {
          r[i] = prev ? (_jac.bytes._isUp(b[i]) ? b[i] + 32 : b[i]) : (_jac.bytes._isLo(b[i]) ? b[i] - 32 : b[i]);
          prev = true;
        } else { r[i] = b[i]; prev = false; }
      }
      return r;
    },
    swapcase(b) {
      const r = new Uint8Array(b.length);
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) r[i] = b[i] + 32;
        else if (_jac.bytes._isLo(b[i])) r[i] = b[i] - 32;
        else r[i] = b[i];
      }
      return r;
    },
    center(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const total = width - b.length;
      const left = Math.floor(total / 2);
      const r = new Uint8Array(width);
      r.fill(f, 0, left); r.set(b, left); r.fill(f, left + b.length);
      return r;
    },
    ljust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      r.set(b); r.fill(f, b.length);
      return r;
    },
    rjust(b, width, fb) {
      const f = fb || 32;
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      const off = width - b.length;
      r.fill(f, 0, off); r.set(b, off);
      return r;
    },
    zfill(b, width) {
      if (b.length >= width) return b.slice();
      const r = new Uint8Array(width);
      let off = 0;
      if (b.length > 0 && (b[0] === 43 || b[0] === 45)) { r[0] = b[0]; off = 1; }
      const pad = width - b.length;
      r.fill(48, off, off + pad);
      for (let i = off; i < b.length; i++) r[pad + i] = b[i];
      return r;
    },
    expandtabs(b, tabsize) {
      const ts = tabsize === undefined ? 8 : tabsize;
      const r = [];
      let col = 0;
      for (let i = 0; i < b.length; i++) {
        if (b[i] === 9) { const sp = ts - (col % ts); for (let j = 0; j < sp; j++) r.push(32); col += sp; }
        else if (b[i] === 10 || b[i] === 13) { r.push(b[i]); col = 0; }
        else { r.push(b[i]); col++; }
      }
      return new Uint8Array(r);
    },
    translate(b, table, del_) {
      const r = [];
      const ds = del_ ? new Set(del_) : null;
      for (let i = 0; i < b.length; i++) {
        if (ds && ds.has(b[i])) continue;
        r.push(table && table[b[i]] !== undefined ? table[b[i]] : b[i]);
      }
      return new Uint8Array(r);
    },
    maketrans(from_, to_) {
      const t = new Uint8Array(256);
      for (let i = 0; i < 256; i++) t[i] = i;
      for (let i = 0; i < from_.length; i++) t[from_[i]] = to_[i];
      return t;
    },
    isalnum(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i]) && !_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    isalpha(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isAl(b[i])) return false;
      return true;
    },
    isascii(b) {
      for (let i = 0; i < b.length; i++) if (b[i] > 127) return false;
      return true;
    },
    isdigit(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isDig(b[i])) return false;
      return true;
    },
    islower(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) return false;
        if (_jac.bytes._isLo(b[i])) has = true;
      }
      return has;
    },
    isupper(b) {
      let has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isLo(b[i])) return false;
        if (_jac.bytes._isUp(b[i])) has = true;
      }
      return has;
    },
    isspace(b) {
      if (b.length === 0) return false;
      for (let i = 0; i < b.length; i++) if (!_jac.bytes._isWS(b[i])) return false;
      return true;
    },
    istitle(b) {
      let prev = false, has = false;
      for (let i = 0; i < b.length; i++) {
        if (_jac.bytes._isUp(b[i])) { if (prev) return false; prev = true; has = true; }
        else if (_jac.bytes._isLo(b[i])) { if (!prev) return false; prev = true; has = true; }
        else prev = false;
      }
      return has;
    },
    add(a, b) {
      const r = new Uint8Array(a.length + b.length);
      r.set(a); r.set(b, a.length);
      return r;
    },
    mul(b, n) {
      const r = new Uint8Array(b.length * n);
      for (let i = 0; i < n; i++) r.set(b, i * b.length);
      return r;
    },
    mod(b, args) {
      const s = new TextDecoder().decode(b);
      return new TextEncoder().encode(_jac.str.mod(s, args));
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
      return true;
    },
    lt(a, b) {
      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] < b[i]) return true;
        if (a[i] > b[i]) return false;
      }
      return a.length < b.length;
    },
    gt(a, b) { return _jac.bytes.lt(b, a); },
    le(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.lt(a, b); },
    ge(a, b) { return _jac.bytes.eq(a, b) || _jac.bytes.gt(a, b); },
    contains(b, sub) { return _jac.bytes._indexOf(b, sub) !== -1; }
  },

  tuple: {
    count(arr, val) { return _jac.list.count(arr, val); },
    index(arr, val, start, end) { return _jac.list.index(arr, val, start, end); },
    repeat(arr, n) { return _jac.list.repeat(arr, n); },
    eq(a, b) { return _jac.list.eq(a, b); },
    lt(a, b) { return _jac.list.lt(a, b); },
    gt(a, b) { return _jac.list.gt(a, b); },
    le(a, b) { return _jac.list.le(a, b); },
    ge(a, b) { return _jac.list.ge(a, b); }
  },

  range: {
    count(r, val) {
      if (typeof r[Symbol.iterator] === "function") {
        let c = 0;
        for (const v of r) { if (v === val) c++; }
        return c;
      }
      return 0;
    },
    index(r, val) {
      let i = 0;
      for (const v of r) { if (v === val) return i; i++; }
      throw new _jac.exc.ValueError(val + " is not in range");
    },
    eq(a, b) {
      if (a.length !== b.length) return false;
      for (let i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; }
      return true;
    },
    contains(r, val) {
      for (const v of r) { if (v === val) return true; }
      return false;
    }
  },

  builtin: {
    round(n, ndigits) {
      if (ndigits === undefined) return Math.round(n);
      const f = Math.pow(10, ndigits);
      return Math.round(n * f) / f;
    },
    sum(iterable, start) {
      let total = start || 0;
      for (const v of iterable) total += v;
      return total;
    },
    sorted(iterable, key, reverse) {
      const arr = [...iterable];
      if (key) {
        arr.sort((a, b) => {
          const ka = key(a), kb = key(b);
          return ka < kb ? -1 : ka > kb ? 1 : 0;
        });
      } else {
        arr.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
      }
      if (reverse) arr.reverse();
      return arr;
    },
    enumerate(iterable, start) {
      const s = start || 0;
      return [...iterable].map((v, i) => [s + i, v]);
    },
    zip(...iterables) {
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(arrays.map(a => a[i]));
      }
      return result;
    },
    map(fn, ...iterables) {
      if (iterables.length === 1) return [...iterables[0]].map(fn);
      const arrays = iterables.map(it => [...it]);
      const len = Math.min(...arrays.map(a => a.length));
      const result = [];
      for (let i = 0; i < len; i++) {
        result.push(fn(...arrays.map(a => a[i])));
      }
      return result;
    },
    filter(fn, iterable) {
      return [...iterable].filter(fn || (x => x));
    },
    // Python subclass relation over builtin-type *tags* -- the string names
    // (`"str"`, `"int"`, ...) that `exit_builtin_type` lowers builtin types to.
    // `object` is the universal base and `bool` is a subclass of `int`; `tuple`
    // and `frozenset` share JS representations with `list`/`set`, so fold those
    // aliases to their runtime tag first. One source of truth so isinstance and
    // issubclass can never disagree.
    _tagSubclass(subTag, superTag) {
      const fold = (t) => t === "tuple" ? "list" : t === "frozenset" ? "set" : t;
      const sub = fold(subTag), sup = fold(superTag);
      if (sup === "object") return true;
      if (sub === sup) return true;
      if (sup === "int" && sub === "bool") return true;
      return false;
    },
    isinstance(o, classinfo) {
      // isinstance(x, (A, B, ...)) -- the tuple of types lowers to a JS array;
      // match if `o` is an instance of any member.
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.isinstance(o, c)) return true;
        }
        return false;
      }
      // Builtin types lower to a string tag (their Python type name): compare
      // the value's runtime type against it via the shared subclass relation.
      if (typeof classinfo === "string") {
        return _jac.builtin._tagSubclass(_jac.poly._typename(o), classinfo);
      }
      // User archetype / JS constructor.
      if (typeof classinfo === "function") return o instanceof classinfo;
      return false;
    },
    issubclass(cls, classinfo) {
      if (Array.isArray(classinfo)) {
        for (const c of classinfo) {
          if (_jac.builtin.issubclass(cls, c)) return true;
        }
        return false;
      }
      // When either side is a builtin-type tag, compare by the shared subclass
      // relation (covers `object`, `bool` ⊂ `int`, and identity).
      if (typeof cls === "string" || typeof classinfo === "string") {
        return _jac.builtin._tagSubclass(cls, classinfo);
      }
      if (cls === classinfo) return true;
      let proto = cls;
      while (proto) {
        if (proto === classinfo) return true;
        proto = Object.getPrototypeOf(proto);
      }
      return false;
    },
    id(o) {
      if (o === null || o === undefined) return 0;
      if (typeof o === "number") return o;
      return typeof o === "string" ? _jac.builtin._strHash(o) : 0;
    },
    _strHash(s) {
      let h = 0;
      for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h + s.charCodeAt(i)) | 0;
      }
      return h;
    },
    jid(obj) {
      if (obj === null || obj === undefined) {
        throw new _jac.exc.TypeError(
          "jid() called on " + String(obj)
          + " -- the server may have returned an error instead of a node."
          + " Check that your endpoint returned successfully before using jid()."
        );
      }
      if (obj._jac_id === undefined) {
        throw new _jac.exc.TypeError(
          "jid() expected a node or edge with graph identity, but received "
          + (typeof obj === "object" ? JSON.stringify(Object.keys(obj)) : typeof obj)
          + ". Only node and edge archetypes have a jid."
        );
      }
      return obj._jac_id;
    },
    // unsafe_html(x) returns a sentinel object that the JSX flattener
    // recognises and renders as raw HTML via dangerouslySetInnerHTML.
    // Named "unsafe" so the security implication is visible at the use site.
    unsafe_html(html) {
      return { __jacUnsafeHtml: String(html == null ? "" : html) };
    },
    hash(obj) { return _jac.builtin.id(obj); },
    repr(obj) { return JSON.stringify(obj); },
    pow(base, exp, mod) {
      let result = Math.pow(base, exp);
      if (mod !== undefined) result = ((result % mod) + mod) % mod;
      return result;
    },
    next(iter, default_) {
      const result = iter.next();
      if (result.done) {
        if (default_ !== undefined) return default_;
        throw new _jac.exc.StopIteration("StopIteration");
      }
      return result.value;
    },
    vars(o) {
      if (o === undefined) return {};
      const result = {};
      for (const [k, v] of Object.entries(o)) {
        if (typeof v !== "function") result[k] = v;
      }
      return result;
    },
    dir(o) {
      if (o === undefined) return [];
      return Object.getOwnPropertyNames(o).sort();
    },
    open() { throw new _jac.exc.OSError("open() is not supported in client-side JavaScript"); },
    format(value, format_spec) {
      if (!format_spec) return String(value);
      return String(value);
    },
    ascii(obj) {
      if (typeof obj === "string") {
        let r = "'";
        for (const c of obj) {
          const code = c.charCodeAt(0);
          if (c === "\\") r += "\\\\";
          else if (c === "'") r += "\\'";
          else if (code >= 0x20 && code <= 0x7e) r += c;
          else if (code < 0x100) r += "\\x" + code.toString(16).padStart(2, "0");
          else r += "\\u" + code.toString(16).padStart(4, "0");
        }
        return r + "'";
      }
      return String(obj);
    },
    complex(re, im) { return {re: re || 0, im: im || 0}; },
    bool(x) {
      if (x === null || x === undefined || x === false || x === 0 || x === "" || Number.isNaN(x)) return false;
      if (Array.isArray(x)) return x.length > 0;
      if (x instanceof Set || x instanceof Map) return x.size > 0;
      if (typeof x === "object") return Object.keys(x).length > 0;
      return true;
    },
    range(...args) {
      let start, stop, step;
      if (args.length === 1) { start = 0; stop = args[0]; step = 1; }
      else if (args.length === 2) { start = args[0]; stop = args[1]; step = 1; }
      else { start = args[0]; stop = args[1]; step = args[2]; }
      if (step === 0) throw new _jac.exc.ValueError("range() arg 3 must not be zero");
      const result = [];
      if (step > 0) { for (let i = start; i < stop; i += step) result.push(i); }
      else { for (let i = start; i > stop; i += step) result.push(i); }
      return result;
    },
    slice(...args) {
      if (args.length === 1) return { start: null, stop: args[0], step: null };
      return { start: args[0] !== undefined ? args[0] : null, stop: args[1] !== undefined ? args[1] : null, step: args[2] !== undefined ? args[2] : null };
    },
    format(value, format_spec) {
      if (!format_spec || format_spec === "") return String(value);
      const m = format_spec.match(/^([<>^]?)(\d+)?(?:\.(\d+))?([dfseboxXn%]?)$/);
      if (!m) return String(value);
      const [, align, widthStr, precStr, ftype] = m;
      let s;
      const prec = precStr !== undefined ? parseInt(precStr) : undefined;
      if (ftype === "f" || ftype === "") {
        s = prec !== undefined ? Number(value).toFixed(prec) : String(value);
      } else if (ftype === "d") {
        s = String(Math.floor(Number(value)));
      } else if (ftype === "b") {
        s = Number(value).toString(2);
      } else if (ftype === "o") {
        s = Number(value).toString(8);
      } else if (ftype === "x") {
        s = Number(value).toString(16);
      } else if (ftype === "X") {
        s = Number(value).toString(16).toUpperCase();
      } else if (ftype === "e") {
        s = prec !== undefined ? Number(value).toExponential(prec) : Number(value).toExponential();
      } else if (ftype === "%") {
        s = (prec !== undefined ? (Number(value) * 100).toFixed(prec) : (Number(value) * 100).toFixed(6)) + "%";
      } else if (ftype === "s" || ftype === "n") {
        s = String(value);
      } else {
        s = String(value);
      }
      if (widthStr) {
        const width = parseInt(widthStr);
        if (s.length < width) {
          const pad = " ".repeat(width - s.length);
          if (align === "<") s = s + pad;
          else if (align === "^") {
            const left = Math.floor((width - s.length) / 2);
            s = " ".repeat(left) + s + " ".repeat(width - s.length - left);
          }
          else s = pad + s;
        }
      }
      return s;
    }
  },

  exc: (() => {
    class BaseException extends Error { constructor(m) { super(m); this.name = 'BaseException'; } }
    class Exception extends BaseException { constructor(m) { super(m); this.name = 'Exception'; } }
    class ArithmeticError extends Exception { constructor(m) { super(m); this.name = 'ArithmeticError'; } }
    class ZeroDivisionError extends ArithmeticError { constructor(m) { super(m); this.name = 'ZeroDivisionError'; } }
    class OverflowError extends ArithmeticError { constructor(m) { super(m); this.name = 'OverflowError'; } }
    class FloatingPointError extends ArithmeticError { constructor(m) { super(m); this.name = 'FloatingPointError'; } }
    class LookupError extends Exception { constructor(m) { super(m); this.name = 'LookupError'; } }
    class IndexError extends LookupError { constructor(m) { super(m); this.name = 'IndexError'; } }
    class KeyError extends LookupError { constructor(m) { super(m); this.name = 'KeyError'; } }
    class ValueError extends Exception { constructor(m) { super(m); this.name = 'ValueError'; } }
    class TypeError_ extends Exception { constructor(m) { super(m); this.name = 'TypeError'; } }
    class AttributeError extends Exception { constructor(m) { super(m); this.name = 'AttributeError'; } }
    class RuntimeError extends Exception { constructor(m) { super(m); this.name = 'RuntimeError'; } }
    class NotImplementedError extends RuntimeError { constructor(m) { super(m); this.name = 'NotImplementedError'; } }
    class RecursionError extends RuntimeError { constructor(m) { super(m); this.name = 'RecursionError'; } }
    class OSError extends Exception { constructor(m) { super(m); this.name = 'OSError'; } }
    class FileNotFoundError extends OSError { constructor(m) { super(m); this.name = 'FileNotFoundError'; } }
    class FileExistsError extends OSError { constructor(m) { super(m); this.name = 'FileExistsError'; } }
    class PermissionError extends OSError { constructor(m) { super(m); this.name = 'PermissionError'; } }
    class TimeoutError extends OSError { constructor(m) { super(m); this.name = 'TimeoutError'; } }
    class IsADirectoryError extends OSError { constructor(m) { super(m); this.name = 'IsADirectoryError'; } }
    class NotADirectoryError extends OSError { constructor(m) { super(m); this.name = 'NotADirectoryError'; } }
    class AssertionError extends Exception { constructor(m) { super(m); this.name = 'AssertionError'; } }
    class ImportError extends Exception { constructor(m) { super(m); this.name = 'ImportError'; } }
    class ModuleNotFoundError extends ImportError { constructor(m) { super(m); this.name = 'ModuleNotFoundError'; } }
    class NameError extends Exception { constructor(m) { super(m); this.name = 'NameError'; } }
    class UnboundLocalError extends NameError { constructor(m) { super(m); this.name = 'UnboundLocalError'; } }
    class StopIteration extends Exception { constructor(m) { super(m); this.name = 'StopIteration'; } }
    class StopAsyncIteration extends Exception { constructor(m) { super(m); this.name = 'StopAsyncIteration'; } }
    class EOFError extends Exception { constructor(m) { super(m); this.name = 'EOFError'; } }
    class MemoryError extends Exception { constructor(m) { super(m); this.name = 'MemoryError'; } }
    class ReferenceError_ extends Exception { constructor(m) { super(m); this.name = 'ReferenceError'; } }
    class KeyboardInterrupt extends BaseException { constructor(m) { super(m); this.name = 'KeyboardInterrupt'; } }
    class SystemExit extends BaseException { constructor(m) { super(m); this.name = 'SystemExit'; } }
    class GeneratorExit extends BaseException { constructor(m) { super(m); this.name = 'GeneratorExit'; } }
    const _all = { BaseException, Exception, ArithmeticError, ZeroDivisionError, OverflowError, FloatingPointError, LookupError, IndexError, KeyError, ValueError, TypeError: TypeError_, AttributeError, RuntimeError, NotImplementedError, RecursionError, OSError, FileNotFoundError, FileExistsError, PermissionError, TimeoutError, IsADirectoryError, NotADirectoryError, AssertionError, ImportError, ModuleNotFoundError, NameError, UnboundLocalError, StopIteration, StopAsyncIteration, EOFError, MemoryError, ReferenceError: ReferenceError_, KeyboardInterrupt, SystemExit, GeneratorExit };
    function matches(e, name) {
      if (name === 'BaseException') return true;
      if (name === 'Exception') return (e instanceof _all.Exception) || !(e instanceof _all.BaseException);
      const cls = _all[name];
      return cls ? (e instanceof cls) : false;
    }
    return Object.assign(_all, { matches });
  })()
};
function EditorShell(props) {
  const {onExit: onExit = null} = props;
  const [activeTool, setActiveTool] = useState("select");
  const [toolLocked, setToolLocked] = useState(false);
  const [drawKind, setDrawKind] = useState("rectangle");
  const [selected, setSelected] = useState(null);
  const [styleN, setStyleN] = useState(0);
  const [stylePatch, setStylePatch] = useState({});
  const [theme, setTheme] = useState("light");
  const [gridOn, setGridOn] = useState(true);
  const [rightTab, setRightTab] = useState("properties");
  const [leftOpen, setLeftOpen] = useState(true);
  const [rightOpen, setRightOpen] = useState(true);
  const [leftWidth, setLeftWidth] = useState(204);
  const [rightWidth, setRightWidth] = useState(232);
  const [dragging, setDragging] = useState("");
  const [dragStartX, setDragStartX] = useState(0);
  const [dragStartW, setDragStartW] = useState(0);
  const [hydrated, setHydrated] = useState(false);
  const [isAuthed, setIsAuthed] = useState(false);
  const [backendReady, setBackendReady] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [authReason, setAuthReason] = useState("");
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [pages, setPages] = useState([{"id": "p1", "name": "Page 1"}]);
  const [activePageId, setActivePageId] = useState("p1");
  const [pageElements, setPageElements] = useState({"p1": []});
  const [pageSeq, setPageSeq] = useState(100);
  const [commandN, setCommandN] = useState(0);
  const [commandName, setCommandName] = useState("");
  const [commandArg, setCommandArg] = useState(null);
  const [selectN, setSelectN] = useState(0);
  const [selectId, setSelectId] = useState(null);
  const [insertN, setInsertN] = useState(0);
  const [insertStencil, setInsertStencil] = useState(null);
  const [pageComments, setPageComments] = useState({});
  const [activeCommentId, setActiveCommentId] = useState(null);
  const [commentSeq, setCommentSeq] = useState(0);
  const [userLibraries, setUserLibraries] = useState([]);
  const [libSeq, setLibSeq] = useState(0);
  const [trashOpen, setTrashOpen] = useState(false);
  const [trashList, setTrashList] = useState([]);
  const [pageConfirmDelete, setPageConfirmDelete] = useState("");
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyList, setHistoryList] = useState([]);
  const [previewSnap, setPreviewSnap] = useState("");
  const [collabId, setCollabId] = useState("");
  const [diagramId, setDiagramId] = useState("");
  const [diagramName, setDiagramName] = useState("Untitled");
  const [openTabs, setOpenTabs] = useState([]);
  const [folderPath, setFolderPath] = useState([]);
  const [diagramNotFound, setDiagramNotFound] = useState(false);
  const [shareBase, setShareBase] = useState("");
  const clientRef = useRef(null);
  const [collabSelf, setCollabSelf] = useState(null);
  const [shareLink, setShareLink] = useState("");
  const [shareToast, setShareToast] = useState("");
  const [notice, setNotice] = useState("");
  const [supporterCycle, setSupporterCycle] = useState("");
  const [isSupporter, setIsSupporter] = useState(false);
  const [supporterBusy, setSupporterBusy] = useState(false);
  const [supporterToast, setSupporterToast] = useState("");
  const [quotaWarned, setQuotaWarned] = useState(false);
  const cursorsRef = useRef({});
  const peersRef = useRef({});
  const [collabTick, setCollabTick] = useState(0);
  const [collabSyncN, setCollabSyncN] = useState(0);
  const [collabSyncEls, setCollabSyncEls] = useState([]);
  const [collabSyncPageId, setCollabSyncPageId] = useState("");
  const [saveShareN, setSaveShareN] = useState(0);
  const pageElementsRef = useRef({});
  const activePageIdRef = useRef("p1");
  const legacyMirrorRef = useRef(false);
  const pageCommentsRef = useRef({});
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [shareAccess, setShareAccess] = useState("restricted");
  const [shareLinkRole, setShareLinkRole] = useState("viewer");
  const [sharePeople, setSharePeople] = useState([]);
  const [myRole, setMyRole] = useState("editor");
  const [shareOwnerIsMe, setShareOwnerIsMe] = useState(true);
  const [myIds, setMyIds] = useState([]);
  const [shareDenied, setShareDenied] = useState(false);
  const [shareScope, setShareScope] = useState("doc");
  const [sharePageId, setSharePageId] = useState("");
  const [shareTitle, setShareTitle] = useState("Untitled");
  const [contributeOpen, setContributeOpen] = useState(false);
  const [shortcutsOpen, setShortcutsOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [findOpen, setFindOpen] = useState(false);
  const [templateOpen, setTemplateOpen] = useState(false);
  let navigate = useNavigate();
  function set_left(v) {
    setLeftOpen(v);
    try {
      localStorage.setItem("libredraw:leftOpen", (v ? "1" : "0"));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }
  function set_right(v) {
    setRightOpen(v);
    try {
      localStorage.setItem("libredraw:rightOpen", (v ? "1" : "0"));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }
  function dispatch(name) {
    setCommandArg(null);
    setCommandName(name);
    setCommandN((commandN + 1));
  }
  function dispatch_arg(name, arg) {
    setCommandArg(arg);
    setCommandName(name);
    setCommandN((commandN + 1));
  }
  async function show_connected(sid) {
    if (((!backendReady || collabId) || !sid)) {
      return;
    }
    let res = await __jacSpawn("ConnectedShapes", "", {"shape_id": sid, "diagram_id": diagramId});
    let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
    if (((rep !== null) && _jac.poly.contains(rep, "connected"))) {
      dispatch_arg("selectIds", [...[sid], ...Array.from(rep["connected"])]);
    }
  }
  function select_layer(id) {
    setSelectId(id);
    setSelectN((selectN + 1));
  }
  function page_name(pid) {
    for (const pg of pages) {
      if ((pg["id"] === pid)) {
        return pg["name"];
      }
    }
    return "Page";
  }
  function snap_rel(iso) {
    if (!iso) {
      return "";
    }
    try {
      let secs = ((Date.now() - Reflect.construct(Date, [iso]).getTime()) / 1000.0);
      if ((secs < 60)) {
        return "just now";
      }
      if ((secs < 3600)) {
        return (String(Math.trunc(Number((secs / 60)))) + "m ago");
      }
      if ((secs < 86400)) {
        return (String(Math.trunc(Number((secs / 3600)))) + "h ago");
      }
      if ((secs < 604800)) {
        return (String(Math.trunc(Number((secs / 86400)))) + "d ago");
      }
      return Reflect.construct(Date, [iso]).toLocaleDateString();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        return "";
      } else {
        throw __jac_e;
      }
    }
  }
  function page_order(pid) {
    for (const i of _jac.builtin.range(pages.length)) {
      if ((_jac.poly.getitem(pages, i)["id"] === pid)) {
        return i;
      }
    }
    return 0;
  }
  function cur_elements() {
    if (_jac.poly.contains(pageElements, activePageId)) {
      return _jac.poly.getitem(pageElements, activePageId);
    }
    return [];
  }
  function sel_ids() {
    if ((selected === null)) {
      return [];
    }
    return (_jac.poly.contains(selected, "_ids") ? selected["_ids"] : []);
  }
  async function hydrate(did = "") {
    let res = await __jacSpawn("LoadDoc", "", {"diagram_id": (did || diagramId)});
    if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
      let doc = res.reports[0];
      if ((doc && doc["not_found"])) {
        setDiagramNotFound(true);
        setHydrated(true);
        forget_open_tab((did || diagramId));
        return;
      }
      if ((doc && (doc.length > 0))) {
        let newpages = [];
        let newmap = {};
        let newcmts = {};
        let startid = doc[0]["id"];
        for (const pg of doc) {
          newpages = [...newpages, ...[{"id": pg["id"], "name": pg["name"]}]];
          newmap[pg["id"]] = pg["elements"];
          newcmts[pg["id"]] = (_jac.poly.contains(pg, "comments") ? pg["comments"] : []);
        }
        setPages(newpages);
        setPageElements(newmap);
        setPageComments(newcmts);
        let saved_active = "";
        let m = load_pages_local();
        if ((m && m["active"])) {
          saved_active = String(m["active"]);
        }
        let found = false;
        for (const p of newpages) {
          if ((p["id"] === saved_active)) {
            found = true;
          }
        }
        setActivePageId(((saved_active && found) ? String(saved_active) : String(startid)));
        setCollabSyncEls(((activePageId in newmap) ? newmap[activePageId] : []));
        setCollabSyncPageId(activePageId);
        setCollabSyncN(Date.now());
        let maxseq = pageSeq;
        for (const pg of newpages) {
          let n = Math.trunc(Number(pg["id"].slice(1)));
          if ((n > maxseq)) {
            maxseq = n;
          }
        }
        setPageSeq(maxseq);
      }
    }
    let libres = await __jacSpawn("LoadLibraries", "", {});
    if (_jac.builtin.bool(_jac.poly.and_(libres.reports, () => (libres.reports.length > 0)))) {
      set_libraries(libres.reports[0]);
    }
    let fp_id = (did || diagramId);
    if ((fp_id !== "")) {
      let fpres = await __jacSpawn("DiagramFolderPath", "", {"diagram_id": fp_id});
      if (_jac.builtin.bool(_jac.poly.and_(_jac.poly.and_(fpres.reports, () => (fpres.reports.length > 0)), () => _jac.poly.contains(fpres.reports[0], "path")))) {
        setFolderPath(fpres.reports[0]["path"]);
      }
    } else {
      setFolderPath([]);
    }
    try {
      localStorage.setItem("libredraw:lastDiagram", (did || diagramId));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    remember_open_tab((did || diagramId), diagramName);
    setHydrated(true);
  }
  function load_open_tabs() {
    let raw = localStorage.getItem("libredraw:openTabs");
    if (raw) {
      try {
        return JSON.parse(raw);
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let e = __jac_e;
          return [];
        } else {
          throw __jac_e;
        }
      }
    }
    return [];
  }
  function remember_open_tab(did, name) {
    if ((did === "")) {
      return;
    }
    let cur = load_open_tabs();
    let out = [];
    let found = false;
    for (const t of cur) {
      if ((t["id"] === did)) {
        out = [...out, ...[{"id": did, "name": (name || "Untitled")}]];
        found = true;
      } else {
        out = [...out, ...[t]];
      }
    }
    if (!found) {
      out = [...out, ...[{"id": did, "name": (name || "Untitled")}]];
    }
    out = out.slice(0, 8);
    setOpenTabs(out);
    try {
      localStorage.setItem("libredraw:openTabs", JSON.stringify(out));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }
  function close_tab(did) {
    let out = load_open_tabs().filter(t => (t["id"] !== did)).map(t => t);
    setOpenTabs(out);
    try {
      localStorage.setItem("libredraw:openTabs", JSON.stringify(out));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    if ((did === diagramId)) {
      if ((out.length > 0)) {
        navigate(("/canvas?diagram=" + out[0]["id"]));
      } else {
        navigate("/dashboard");
      }
    }
  }
  function forget_open_tab(did) {
    if ((did === "")) {
      return;
    }
    let out = load_open_tabs().filter(t => (t["id"] !== did)).map(t => t);
    setOpenTabs(out);
    try {
      localStorage.setItem("libredraw:openTabs", JSON.stringify(out));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    if (((localStorage.getItem("libredraw:lastDiagram") || "") === did)) {
      try {
        localStorage.removeItem("libredraw:lastDiagram");
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let e = __jac_e;
        } else {
          throw __jac_e;
        }
      }
    }
  }
  function switch_diagram(did) {
    if (((did !== "") && (did !== diagramId))) {
      navigate(("/canvas?diagram=" + did));
    }
  }
  async function boot_document() {
    let did = diagram_param();
    let sid = share_param();
    if (sid) {
      setDiagramId(did);
      await open_shared(sid);
      return;
    }
    if ((did === "")) {
      let last = (localStorage.getItem("libredraw:lastDiagram") || "");
      if (last) {
        navigate(("/canvas?diagram=" + last));
        return;
      }
    }
    setDiagramId(did);
    let dsid = await diagram_share_id(did);
    if (dsid) {
      await open_shared(dsid, did);
    } else {
      hydrate(did);
    }
  }
  async function diagram_share_id(did) {
    let res = await __jacSpawn("DiagramShareId", "", {"diagram_id": did});
    if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
      let rep = res.reports[0];
      let nm = rep["name"];
      if (nm) {
        setDiagramName(String(nm));
      }
      let sid = rep["share_id"];
      return (sid ? String(sid) : "");
    }
    return "";
  }
  async function rename_doc(nm) {
    let cleaned = _jac.poly.call(nm, "strip");
    let res = await __jacSpawn("RenameDiagram", "", {"diagram_id": diagramId, "name": cleaned});
    let newname = (cleaned || "Untitled");
    if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
      let rep = res.reports[0];
      let rn = rep["name"];
      if (rn) {
        newname = String(rn);
      }
    }
    setDiagramName(newname);
    remember_open_tab(diagramId, newname);
  }
  async function ensure_backend(real) {
    if (real) {
      setBackendReady(true);
      boot_document();
      return;
    }
    let ok = await guest_session();
    if (ok) {
      setBackendReady(true);
      boot_document();
    } else {
      let saved = load_pages_local();
      let startPage = activePageId;
      if (((saved && saved["pages"]) && (saved["pages"].length > 0))) {
        setPages(saved["pages"]);
        startPage = (saved["active"] ? saved["active"] : saved["pages"][0]["id"]);
        setActivePageId(startPage);
        if (saved["seq"]) {
          setPageSeq(saved["seq"]);
        }
      }
      set_comments(startPage, load_comments(startPage));
      setUserLibraries(load_libraries_local());
      setHydrated(true);
    }
  }
  async function guest_session() {
    let raw = localStorage.getItem("libredraw:guest");
    if (raw) {
      let g = JSON.parse(raw);
      let ok = await jacLogin(g["u"], g["p"]);
      if (ok) {
        return true;
      }
    }
    let u = (("guest_" + String(Math.floor((Math.random() * 1000000000)))) + String(Math.floor((Math.random() * 1000000))));
    let pw = ("g_" + String(Math.floor((Math.random() * 1000000000000))));
    await jacSignup(u, pw);
    let ok2 = await jacLogin(u, pw);
    if (ok2) {
      localStorage.setItem("libredraw:guest", JSON.stringify({"u": u, "p": pw}));
      localStorage.setItem("libredraw:authMode", "guest");
      return true;
    }
    return false;
  }
  async function persist(pid, els) {
    if (diagramNotFound) {
      return;
    }
    if (previewSnap) {
      return;
    }
    let m = {...pageElements};
    m[pid] = Array.from(els);
    setPageElements(m);
    if ((backendReady && !collabId)) {
      try {
        await __jacSpawn("SavePage", "", {"page_id": pid, "name": page_name(pid), "elements": Array.from(els), "order": page_order(pid), "diagram_id": diagramId});
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let e = __jac_e;
          setNotice("Couldn't save to the server - your changes are kept on this device. Check your connection.");
        } else {
          throw __jac_e;
        }
      }
    }
  }
  function share_param() {
    return (_jac.poly.call(Reflect.construct(URLSearchParams, [location.search]), "get", "share") || "");
  }
  function diagram_param() {
    return (_jac.poly.call(Reflect.construct(URLSearchParams, [location.search]), "get", "diagram") || "");
  }
  function mirror_did() {
    return (diagram_param() || "default");
  }
  function page_key(pid) {
    return ((("libredraw:page:" + mirror_did()) + ":") + pid);
  }
  function color_for(sid) {
    let palette = ["#4f46e5", "#0ea5e9", "#059669", "#dc2626", "#d97706", "#7c3aed", "#db2777", "#0891b2"];
    let h = 0;
    for (const ch of sid) {
      h = _jac.int.mod(((h * 31) + ch.codePointAt(0)), 9973);
    }
    return palette.at(_jac.int.mod(h, palette.length));
  }
  function one_page_payload(pid, order) {
    for (const pg of pages) {
      if ((pg["id"] === pid)) {
        return {"id": pid, "name": pg["name"], "elements": (_jac.poly.contains(pageElements, pid) ? _jac.poly.getitem(pageElements, pid) : []), "comments": (_jac.poly.contains(pageComments, pid) ? _jac.poly.getitem(pageComments, pid) : []), "order": order};
      }
    }
    return null;
  }
  function payload_for(scope, pid) {
    if ((scope === "page")) {
      let p = one_page_payload(pid, 0);
      return ((p !== null) ? [p] : []);
    }
    let out = [];
    let i = 0;
    for (const pg of pages) {
      out = [...out, ...[one_page_payload(pg["id"], i)]];
      i = (i + 1);
    }
    return out;
  }
  function shared_pages_payload() {
    return payload_for(shareScope, sharePageId);
  }
  function page_in_share(pid) {
    if ((shareScope === "page")) {
      return (pid === sharePageId);
    }
    return true;
  }
  async function load_my_ids() {
    let tok = (localStorage.getItem("jac_token") || "");
    setMyIds(await myIdentities(tok));
  }
  function can_edit() {
    if (!collabId) {
      return true;
    }
    return ((myRole === "owner") || (myRole === "editor"));
  }
  function can_comment() {
    if (!collabId) {
      return true;
    }
    return (((myRole === "owner") || (myRole === "editor")) || (myRole === "commenter"));
  }
  async function copy_share_link() {
    let link = shareLink;
    if (!collabId) {
      let sid = await ensure_share("restricted", (shareLinkRole || "viewer"), sharePeople);
      if (!sid) {
        return;
      }
      link = (((window.location.origin + window.location.pathname) + "?share=") + sid);
    }
    try {
      navigator.clipboard.writeText(link);
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }
  function page_is_shared() {
    if (!collabId) {
      return false;
    }
    if ((shareScope === "page")) {
      return (sharePageId === activePageId);
    }
    return true;
  }
  function page_access_label() {
    if (!page_is_shared()) {
      return "Private";
    }
    if ((shareAccess === "restricted")) {
      return "Restricted";
    }
    return "Anyone with link";
  }
  function open_share_dialog(scope, pid, ttl) {
    setShareScope(scope);
    setSharePageId(pid);
    setShareTitle(ttl);
    setShareDialogOpen(true);
  }
  function share_doc() {
    open_share_dialog("doc", "", (diagramName || "Untitled"));
  }
  function share_page() {
    open_share_dialog("page", activePageId, page_name(activePageId));
  }
  async function ensure_share(access, link_role, people) {
    if (collabId) {
      return collabId;
    }
    if (!backendReady) {
      return "";
    }
    let res = await __jacSpawn("CreateShare", "", {"pages": payload_for(shareScope, sharePageId), "title": ((shareTitle || diagramName) || "Untitled"), "access": access, "link_role": link_role, "people": Array.from(people), "diagram_id": diagramId});
    if (_jac.builtin.bool(_jac.poly.and_(_jac.poly.and_(res.reports, () => (res.reports.length > 0)), () => res.reports[0]["ok"]))) {
      let sid = res.reports[0]["share_id"];
      setShareLink((((window.location.origin + window.location.pathname) + "?share=") + sid));
      setMyRole("owner");
      setShareOwnerIsMe(true);
      start_collab(sid);
      return sid;
    }
    return "";
  }
  async function stop_sharing() {
    if ((!collabId || !shareOwnerIsMe)) {
      setShareDialogOpen(false);
      return;
    }
    await __jacSpawn("StopSharing", "", {"share_id": collabId, "diagram_id": diagramId});
    if ((clientRef.current !== null)) {
      try {
        clientRef.current.close();
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let e = __jac_e;
        } else {
          throw __jac_e;
        }
      }
      clientRef.current = null;
    }
    setCollabId("");
    setShareLink("");
    setShareBase("");
    setShareAccess("restricted");
    setShareLinkRole("viewer");
    setSharePeople([]);
    setMyRole("editor");
    setShareOwnerIsMe(true);
    setShareDialogOpen(false);
    setNotice("Sharing turned off - this diagram is private again.");
  }
  async function push_access(access, link_role, people) {
    if ((collabId && shareOwnerIsMe)) {
      await __jacSpawn("SetShareAccess", "", {"share_id": collabId, "access": access, "link_role": link_role, "people": Array.from(people)});
    }
  }
  async function set_access_mode(mode) {
    if (!collabId) {
      if ((mode === "link")) {
        if (await ensure_share("link", (shareLinkRole || "viewer"), sharePeople)) {
          setShareAccess("link");
        }
      } else {
        setShareAccess("restricted");
      }
      return;
    }
    setShareAccess(mode);
    push_access(mode, shareLinkRole, sharePeople);
  }
  async function set_link_role(role) {
    setShareLinkRole(role);
    if (collabId) {
      push_access(shareAccess, role, sharePeople);
    }
  }
  async function add_person(email, role) {
    let np = [...sharePeople.filter(p => (p["email"] !== email)).map(p => p), ...[{"email": email, "role": role}]];
    setSharePeople(np);
    if (!collabId) {
      let mode = ((shareAccess === "link") ? "link" : "restricted");
      if (await ensure_share(mode, (shareLinkRole || "viewer"), np)) {
        setShareAccess(mode);
      }
      return;
    }
    push_access(shareAccess, shareLinkRole, np);
  }
  function set_person_role(email, role) {
    let np = [];
    for (const p of sharePeople) {
      if ((p["email"] === email)) {
        np = [...np, ...[{"email": email, "role": role}]];
      } else {
        np = [...np, ...[p]];
      }
    }
    setSharePeople(np);
    push_access(shareAccess, shareLinkRole, np);
  }
  function remove_person(email) {
    let np = sharePeople.filter(p => (p["email"] !== email)).map(p => p);
    setSharePeople(np);
    push_access(shareAccess, shareLinkRole, np);
  }
  function start_collab(sid) {
    if ((clientRef.current !== null)) {
      return;
    }
    setCollabId(sid);
    let me = makeCollaborator();
    setCollabSelf(me);
    let tok = (localStorage.getItem("jac_token") || "");
    let client = createCollab({"shareId": sid, "token": tok, "selfId": me["id"], "selfName": me["name"], "onMessage": msg => {
      handle_collab(msg);
    }, "onStatus": up => {}});
    clientRef.current = client;
    client.connect();
  }
  async function open_shared(sid, fallback_did = "") {
    await load_my_ids();
    await __jacSpawn("AcceptInvite", "", {"share_id": sid, "ids": myIds});
    let res = await __jacSpawn("OpenShare", "", {"share_id": sid});
    if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
      let r = res.reports[0];
      if (!r["ok"]) {
        if ((_jac.poly.contains(r, "error") && (r["error"] === "denied"))) {
          setShareDenied(true);
          setHydrated(true);
          return;
        }
        if ((fallback_did !== "")) {
          await hydrate(fallback_did);
          return;
        }
        setDiagramNotFound(true);
        setHydrated(true);
        return;
      }
      setMyRole(r["role"]);
      setShareOwnerIsMe((r["role"] === "owner"));
      setShareAccess((_jac.poly.contains(r, "access") ? r["access"] : "link"));
      setShareLinkRole((_jac.poly.contains(r, "link_role") ? r["link_role"] : "editor"));
      setSharePeople((_jac.poly.contains(r, "people") ? r["people"] : []));
      setShareTitle((_jac.poly.contains(r, "title") ? r["title"] : "Shared diagram"));
      setShareBase((_jac.poly.contains(r, "updated_at") ? r["updated_at"] : ""));
      setShareScope("doc");
      setSharePageId("");
      setShareLink((((window.location.origin + window.location.pathname) + "?share=") + sid));
      let doc = r["pages"];
      if ((doc && (doc.length > 0))) {
        let newpages = [];
        let newmap = {};
        let newcmts = {};
        for (const pg of doc) {
          newpages = [...newpages, ...[{"id": pg["id"], "name": pg["name"]}]];
          newmap[pg["id"]] = pg["elements"];
          newcmts[pg["id"]] = (_jac.poly.contains(pg, "comments") ? pg["comments"] : []);
        }
        setPages(newpages);
        setPageElements(newmap);
        setPageComments(newcmts);
        setActivePageId(doc[0]["id"]);
        setCollabSyncEls(doc[0]["elements"]);
        setCollabSyncPageId(doc[0]["id"]);
        setCollabSyncN(Date.now());
      }
    }
    setHydrated(true);
    start_collab(sid);
  }
  function handle_collab(m) {
    let sender = m["sender"];
    let kind = m["kind"];
    let pay = m["payload"];
    let col = color_for(sender);
    let peers = peersRef.current;
    if ((peers === null)) {
      peers = {};
      peersRef.current = peers;
    }
    peers[sender] = {"name": m["name"], "color": col};
    if ((kind === "cursor")) {
      let curs = cursorsRef.current;
      if ((curs === null)) {
        curs = {};
        cursorsRef.current = curs;
      }
      curs[sender] = {"id": sender, "name": m["name"], "color": col, "x": pay["x"], "y": pay["y"], "t": Date.now()};
    } else if ((kind === "doc")) {
      let pid = pay["pageId"];
      let els = pay["elements"];
      let base = ((pageElementsRef.current !== null) ? pageElementsRef.current : {});
      let mm = {...base};
      mm[pid] = els;
      pageElementsRef.current = mm;
      setPageElements(mm);
      setCollabSyncEls(els);
      setCollabSyncPageId(pid);
      setCollabSyncN(Date.now());
    } else if ((kind === "comment")) {
      let cpid = pay["pageId"];
      let ccs = pay["comments"];
      let cbase = ((pageCommentsRef.current !== null) ? pageCommentsRef.current : {});
      let cmm = {...cbase};
      cmm[cpid] = ccs;
      pageCommentsRef.current = cmm;
      setPageComments(cmm);
      if (can_edit()) {
        schedule_save_share();
      }
    } else if ((kind === "hello")) {
      let apid = activePageIdRef.current;
      let pe = ((pageElementsRef.current !== null) ? pageElementsRef.current : {});
      broadcast_doc(apid, ((apid in pe) ? pe[apid] : []));
    } else if ((kind === "presence")) {
      if (((pay && _jac.poly.contains(pay, "state")) && (pay["state"] === "leave"))) {
        let c = cursorsRef.current;
        if ((c !== null)) {
          cursorsRef.current = Object.fromEntries(_jac.poly.call(Object, "keys", c).filter(k => (k !== sender)).map(k => [k, c[k]]));
        }
        let p = peersRef.current;
        if ((p !== null)) {
          peersRef.current = Object.fromEntries(_jac.poly.call(Object, "keys", p).filter(k => (k !== sender)).map(k => [k, p[k]]));
        }
      } else {
        let apid = activePageIdRef.current;
        let pe = ((pageElementsRef.current !== null) ? pageElementsRef.current : {});
        broadcast_doc(apid, ((apid in pe) ? pe[apid] : []));
      }
    }
    setCollabTick(Date.now());
  }
  function broadcast_doc(pid, els) {
    let c = clientRef.current;
    if ((c !== null)) {
      c.send("doc", {"pageId": pid, "elements": els});
      schedule_save_share();
    }
  }
  function broadcast_cursor(x, y) {
    let c = clientRef.current;
    if ((c !== null)) {
      c.send("cursor", {"x": x, "y": y});
    }
  }
  async function do_save_share(tok) {
    if (((((tok === saveShareN) && collabId) && backendReady) && can_edit())) {
      try {
        let res = await __jacSpawn("SaveShare", "", {"share_id": collabId, "pages": shared_pages_payload(), "title": ((shareTitle || diagramName) || "Untitled"), "base_updated_at": shareBase});
        let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
        if ((rep !== null)) {
          if (rep["ok"]) {
            setShareBase((_jac.poly.contains(rep, "updated_at") ? rep["updated_at"] : shareBase));
          } else if ((_jac.poly.contains(rep, "error") && (rep["error"] === "stale"))) {
            await open_shared(collabId);
          }
        }
      } catch (__jac_e) {
        if (_jac.exc.matches(__jac_e, "Exception")) {
          let e = __jac_e;
          setNotice("Couldn't save the shared diagram - check your connection.");
        } else {
          throw __jac_e;
        }
      }
    }
  }
  function schedule_save_share() {
    setSaveShareN((saveShareN + 1));
    let tok = saveShareN;
    setTimeout(() => {
      do_save_share(tok);
    }, 700);
  }
  function remote_cursor_list() {
    let now = Date.now();
    let out = [];
    let curs = cursorsRef.current;
    if ((curs === null)) {
      return out;
    }
    for (const k of _jac.poly.call(Object, "keys", curs)) {
      let c = curs[k];
      if (((now - c["t"]) < 6000)) {
        out = [...out, ...[c]];
      }
    }
    return out;
  }
  function collab_count() {
    let p = peersRef.current;
    if ((p === null)) {
      return 1;
    }
    return (_jac.poly.call(Object, "keys", p).length + 1);
  }
  function peer_list() {
    let out = [];
    let p = peersRef.current;
    if ((p !== null)) {
      for (const k of _jac.poly.call(Object, "keys", p)) {
        out = [...out, ...[{"name": p[k]["name"], "color": p[k]["color"]}]];
      }
    }
    return out;
  }
  function next_page_id() {
    let mx = pageSeq;
    for (const pg of pages) {
      let n = Math.trunc(Number(pg["id"].slice(1)));
      if ((n > mx)) {
        mx = n;
      }
    }
    return ("p" + String((mx + 1)));
  }
  async function add_page() {
    let newid = next_page_id();
    let order = pages.length;
    let nm = ("Page " + String((order + 1)));
    let newpages = [...pages, ...[{"id": newid, "name": nm}]];
    setPageSeq(Math.trunc(Number(newid.slice(1))));
    setPages(newpages);
    let me = {...pageElements};
    me[newid] = [];
    setPageElements(me);
    let mc = {...pageComments};
    mc[newid] = [];
    setPageComments(mc);
    setActivePageId(newid);
    setSelected(null);
    save_pages_local(newpages, newid, Math.trunc(Number(newid.slice(1))));
    if (backendReady) {
      await __jacSpawn("SavePage", "", {"page_id": newid, "name": nm, "elements": [], "order": order, "diagram_id": diagramId});
    }
  }
  async function duplicate_page(pid) {
    let src = (_jac.poly.contains(pageElements, pid) ? _jac.poly.getitem(pageElements, pid) : []);
    let newid = next_page_id();
    let order = pages.length;
    let nm = (page_name(pid) + " copy");
    let newpages = [...pages, ...[{"id": newid, "name": nm}]];
    setPageSeq(Math.trunc(Number(newid.slice(1))));
    setPages(newpages);
    let me = {...pageElements};
    me[newid] = Array.from(src);
    setPageElements(me);
    let mc = {...pageComments};
    mc[newid] = [];
    setPageComments(mc);
    setActivePageId(newid);
    setSelected(null);
    save_pages_local(newpages, newid, Math.trunc(Number(newid.slice(1))));
    if (backendReady) {
      await __jacSpawn("SavePage", "", {"page_id": newid, "name": nm, "elements": Array.from(src), "order": order, "diagram_id": diagramId});
    }
  }
  async function rename_page(pid, newname) {
    let np = [];
    for (const pg of pages) {
      if ((pg["id"] === pid)) {
        np = [...np, ...[{"id": pid, "name": newname}]];
      } else {
        np = [...np, ...[pg]];
      }
    }
    setPages(np);
    save_pages_local();
    let els = (_jac.poly.contains(pageElements, pid) ? _jac.poly.getitem(pageElements, pid) : []);
    if (backendReady) {
      await __jacSpawn("SavePage", "", {"page_id": pid, "name": newname, "elements": Array.from(els), "order": page_order(pid), "diagram_id": diagramId});
    }
  }
  function page_el_count(pid) {
    return (_jac.poly.contains(pageElements, pid) ? _jac.poly.getitem(pageElements, pid).length : 0);
  }
  function ask_delete_page(pid) {
    if ((pages.length <= 1)) {
      return;
    }
    if ((page_el_count(pid) === 0)) {
      delete_page(pid);
      return;
    }
    setPageConfirmDelete(pid);
  }
  async function delete_page(pid) {
    setPageConfirmDelete("");
    if ((pages.length <= 1)) {
      return;
    }
    let np = pages.filter(pg => (pg["id"] !== pid)).map(pg => pg);
    setPages(np);
    if ((activePageId === pid)) {
      setActivePageId(np[0]["id"]);
      setSelected(null);
    }
    let me = Object.fromEntries(_jac.poly.call(Object, "keys", pageElements).filter(k => (k !== pid)).map(k => [k, _jac.poly.getitem(pageElements, k)]));
    setPageElements(me);
    let mc = Object.fromEntries(_jac.poly.call(Object, "keys", pageComments).filter(k => (k !== pid)).map(k => [k, _jac.poly.getitem(pageComments, k)]));
    setPageComments(mc);
    localStorage.removeItem(page_key(pid));
    localStorage.removeItem(comments_key(pid));
    setTimeout(() => {
      localStorage.removeItem(page_key(pid));
      localStorage.removeItem(comments_key(pid));
    }, 300);
    save_pages_local();
    if (backendReady) {
      await __jacSpawn("DeletePage", "", {"page_id": pid, "diagram_id": diagramId});
    }
  }
  async function open_trash() {
    if (backendReady) {
      let res = await __jacSpawn("ListTrash", "", {"diagram_id": diagramId});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        setTrashList(res.reports[0]);
      }
    }
    setTrashOpen(true);
  }
  async function open_history() {
    if ((!backendReady || collabId)) {
      return;
    }
    let res = await __jacSpawn("ListSnapshots", "", {"diagram_id": diagramId});
    let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
    setHistoryList(((rep && _jac.poly.contains(rep, "snapshots")) ? Array.from(rep["snapshots"]) : []));
    setHistoryOpen(true);
  }
  function load_pages_from(doc) {
    let newpages = [];
    let newmap = {};
    let newcmts = {};
    for (const pg of doc) {
      newpages = [...newpages, ...[{"id": pg["id"], "name": pg["name"]}]];
      newmap[pg["id"]] = pg["elements"];
      newcmts[pg["id"]] = (_jac.poly.contains(pg, "comments") ? pg["comments"] : []);
    }
    setPages(newpages);
    setPageElements(newmap);
    setPageComments(newcmts);
    setActivePageId(doc[0]["id"]);
    setCollabSyncEls(doc[0]["elements"]);
    setCollabSyncPageId(doc[0]["id"]);
    setCollabSyncN(Date.now());
  }
  async function preview_snapshot(sid) {
    let res = await __jacSpawn("GetSnapshot", "", {"snap_id": sid, "diagram_id": diagramId});
    let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
    if (!(rep && rep["ok"])) {
      return;
    }
    let doc = rep["pages"];
    setPreviewSnap(sid);
    setHistoryOpen(false);
    if ((doc && (doc.length > 0))) {
      load_pages_from(doc);
    }
  }
  async function exit_preview() {
    setPreviewSnap("");
    await hydrate(diagramId);
  }
  async function restore_snapshot(sid) {
    await __jacSpawn("RestoreSnapshot", "", {"snap_id": sid, "diagram_id": diagramId});
    setPreviewSnap("");
    setHistoryOpen(false);
    await hydrate(diagramId);
    setNotice("Version restored. The previous state is kept in version history.");
  }
  async function refresh_trash() {
    if (backendReady) {
      let res = await __jacSpawn("ListTrash", "", {"diagram_id": diagramId});
      if (_jac.builtin.bool(_jac.poly.and_(res.reports, () => (res.reports.length > 0)))) {
        setTrashList(res.reports[0]);
      }
    }
  }
  async function restore_page(pid) {
    let res = await __jacSpawn("RestorePage", "", {"page_id": pid, "diagram_id": diagramId});
    if (_jac.builtin.bool(_jac.poly.and_(_jac.poly.and_(res.reports, () => (res.reports.length > 0)), () => res.reports[0]["ok"]))) {
      let pg = res.reports[0]["page"];
      let rid = pg["id"];
      setPages([...pages, ...[{"id": rid, "name": pg["name"]}]]);
      let me = {...pageElements};
      me[rid] = pg["elements"];
      setPageElements(me);
      let mc = {...pageComments};
      mc[rid] = (_jac.poly.contains(pg, "comments") ? pg["comments"] : []);
      setPageComments(mc);
      setActivePageId(rid);
      setSelected(null);
      setTrashOpen(false);
      save_pages_local();
    }
    refresh_trash();
  }
  async function purge_page(pid) {
    await __jacSpawn("PurgePage", "", {"page_id": pid, "diagram_id": diagramId});
    localStorage.removeItem(page_key(pid));
    localStorage.removeItem(comments_key(pid));
    refresh_trash();
  }
  async function reorder_pages(order) {
    let byid = {};
    for (const pg of pages) {
      byid[pg["id"]] = pg;
    }
    let np = order.filter(pid => (pid in byid)).map(pid => byid[pid]);
    if ((np.length === pages.length)) {
      setPages(np);
    }
    save_pages_local();
    if (backendReady) {
      await __jacSpawn("ReorderPages", "", {"order_ids": Array.from(order), "diagram_id": diagramId});
    }
  }
  function switch_page(pid) {
    if ((pid !== activePageId)) {
      setActivePageId(pid);
      setSelected(null);
      setActiveCommentId(null);
      if (!_jac.poly.contains(pageComments, pid)) {
        set_comments(pid, load_comments(pid));
      }
      save_pages_local();
    }
  }
  function warn_quota() {
    if (!quotaWarned) {
      setQuotaWarned(true);
      setNotice("This device's storage is full - some offline data may not be kept. Your work still saves to the server when you're online.");
    }
  }
  function save_pages_local(pgs = null, active = "", seq = (-1)) {
    let p = ((pgs !== null) ? pgs : pages);
    let a = ((active !== "") ? active : activePageId);
    let s = ((seq >= 0) ? seq : pageSeq);
    try {
      localStorage.setItem(("libredraw:pages:" + mirror_did()), JSON.stringify({"pages": p, "active": a, "seq": s}));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        warn_quota();
      } else {
        throw __jac_e;
      }
    }
  }
  function load_pages_local() {
    let raw = localStorage.getItem(("libredraw:pages:" + mirror_did()));
    if (raw) {
      return JSON.parse(raw);
    }
    return null;
  }
  function cur_comments() {
    if (_jac.poly.contains(pageComments, activePageId)) {
      return _jac.poly.getitem(pageComments, activePageId);
    }
    return [];
  }
  function set_comments(pid, cs) {
    let m = {...pageComments};
    m[pid] = cs;
    setPageComments(m);
  }
  function comments_key(pid) {
    return ((("libredraw:comments:" + mirror_did()) + ":") + pid);
  }
  function load_comments(pid) {
    let raw = localStorage.getItem(comments_key(pid));
    if (raw) {
      return JSON.parse(raw);
    }
    return [];
  }
  async function save_comments(pid, cs) {
    try {
      localStorage.setItem(comments_key(pid), JSON.stringify(cs));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        warn_quota();
      } else {
        throw __jac_e;
      }
    }
    if (backendReady) {
      await __jacSpawn("SaveComments", "", {"page_id": pid, "comments": Array.from(cs), "diagram_id": diagramId});
    }
  }
  function commit_comments(cs) {
    set_comments(activePageId, cs);
    save_comments(activePageId, cs);
    if (collabId) {
      let c = clientRef.current;
      if ((c !== null)) {
        c.send("comment", {"pageId": activePageId, "comments": cs});
      }
      schedule_save_share();
    }
  }
  function place_comment(x, y) {
    setCommentSeq((commentSeq + 1));
    let cid = ("c" + String(commentSeq));
    commit_comments([...cur_comments(), ...[{"id": cid, "x": x, "y": y, "resolved": false, "thread": []}]]);
    setActiveCommentId(cid);
    setRightTab("comments");
    setRightOpen(true);
    setActiveTool("select");
  }
  function open_comment(cid) {
    setActiveCommentId(cid);
    setRightTab("comments");
    setRightOpen(true);
  }
  function add_reply(cid, text) {
    if ((text === "")) {
      return;
    }
    let ncs = [];
    for (const c of cur_comments()) {
      if ((c["id"] === cid)) {
        ncs = [...ncs, ...[{"id": c["id"], "x": c["x"], "y": c["y"], "resolved": c["resolved"], "thread": [...c["thread"], ...[{"author": "You", "text": text}]]}]];
      } else {
        ncs = [...ncs, ...[c]];
      }
    }
    commit_comments(ncs);
  }
  function resolve_comment(cid) {
    let ncs = [];
    for (const c of cur_comments()) {
      if ((c["id"] === cid)) {
        ncs = [...ncs, ...[{"id": c["id"], "x": c["x"], "y": c["y"], "resolved": !c["resolved"], "thread": c["thread"]}]];
      } else {
        ncs = [...ncs, ...[c]];
      }
    }
    commit_comments(ncs);
  }
  function delete_comment(cid) {
    commit_comments(cur_comments().filter(c => (c["id"] !== cid)).map(c => c));
    if ((activeCommentId === cid)) {
      setActiveCommentId(null);
    }
  }
  function insert_stencil(st) {
    setInsertStencil(st);
    setInsertN((insertN + 1));
  }
  function load_libraries_local() {
    let raw = localStorage.getItem("libredraw:libraries");
    if (raw) {
      return JSON.parse(raw);
    }
    return [];
  }
  function set_libraries(libs) {
    setUserLibraries(libs);
    try {
      localStorage.setItem("libredraw:libraries", JSON.stringify(libs));
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        warn_quota();
      } else {
        throw __jac_e;
      }
    }
  }
  async function push_lib(lib) {
    if ((backendReady && (lib !== null))) {
      await __jacSpawn("SaveLibrary", "", {"lib_id": lib["id"], "name": lib["name"], "stencils": lib["stencils"], "published": lib["published"]});
    }
  }
  function add_stencil_to_mine(st) {
    let has_mine = false;
    for (const l of userLibraries) {
      if ((l["id"] === "mine")) {
        has_mine = true;
      }
    }
    if (!has_mine) {
      let lib = {"id": "mine", "name": "My shapes", "stencils": [st], "published": false};
      set_libraries([...userLibraries, ...[lib]]);
      push_lib(lib);
    } else {
      let newlibs = [];
      let updated = null;
      for (const l of userLibraries) {
        if ((l["id"] === "mine")) {
          updated = {"id": "mine", "name": l["name"], "stencils": [...l["stencils"], ...[st]], "published": l["published"]};
          newlibs = [...newlibs, ...[updated]];
        } else {
          newlibs = [...newlibs, ...[l]];
        }
      }
      set_libraries(newlibs);
      push_lib(updated);
    }
  }
  function save_selection_stencil() {
    let ids = sel_ids();
    let src_els = cur_elements().filter(e => (_jac.poly.contains(ids, e["id"]) && (e["kind"] !== "connector"))).map(e => e);
    if ((src_els.length === 0)) {
      return;
    }
    let xs = src_els.map(e => e["x"]);
    let ys = src_els.map(e => e["y"]);
    let cx = ((Math.min(xs) + Math.max(xs)) / 2);
    let cy = ((Math.min(ys) + Math.max(ys)) / 2);
    let stencil_els = [];
    for (const e of src_els) {
      stencil_els = [...stencil_els, ...[{"kind": e["kind"], "dx": (e["x"] - cx), "dy": (e["y"] - cy), "w": e["w"], "h": e["h"], "fill": e["fill"], "stroke": e["stroke"], "strokeWidth": e["strokeWidth"], "text": (_jac.poly.contains(e, "text") ? e["text"] : null), "src": (_jac.poly.contains(e, "src") ? e["src"] : null), "points": (_jac.poly.contains(e, "points") ? e["points"] : null), "closed": (_jac.poly.contains(e, "closed") ? e["closed"] : null), "smooth": (_jac.poly.contains(e, "smooth") ? e["smooth"] : null), "opacity": (_jac.poly.contains(e, "opacity") ? e["opacity"] : null)}]];
    }
    let label = (_jac.poly.contains(src_els[0], "groupName") ? src_els[0]["groupName"] : src_els[0]["kind"]);
    let st = {"label": label, "kind": src_els[0]["kind"], "elements": stencil_els};
    add_stencil_to_mine(st);
    setRightTab("properties");
  }
  async function add_library(name, stencils) {
    setLibSeq((libSeq + 1));
    let lib = {"id": ("lib" + String(libSeq)), "name": name, "stencils": stencils, "published": false};
    set_libraries([...userLibraries, ...[lib]]);
    push_lib(lib);
  }
  async function delete_library(lid) {
    set_libraries(userLibraries.filter(l => (l["id"] !== lid)).map(l => l));
    if (backendReady) {
      await __jacSpawn("DeleteLibrary", "", {"lib_id": lid});
    }
  }
  function strip_query_param(name) {
    let p = Reflect.construct(URLSearchParams, [location.search]);
    p.delete(name);
    let qs = p.toString();
    window.history.replaceState({}, "", (location.pathname + (qs ? ("?" + qs) : "")));
  }
  function clear_supporter_intent() {
    setSupporterCycle("");
    sessionStorage.removeItem("libredraw:supporterIntent");
  }
  async function check_supporter() {
    try {
      let res = await __jacSpawn("MySubscription", "", {});
      let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
      if (((rep !== null) && rep["subscription"]["supporter"])) {
        setIsSupporter(true);
        clear_supporter_intent();
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  }
  async function on_checkout_completed(d) {
    setSupporterBusy(false);
    try {
      let res = await __jacSpawn("MySubscription", "", {"customer_id": (d ? (d["customerId"] || "") : ""), "transaction_id": (d ? (d["transactionId"] || "") : ""), "subscription_id": (d ? (d["subscriptionId"] || "") : ""), "refresh": true});
      let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
      if (((rep !== null) && rep["subscription"]["supporter"])) {
        setIsSupporter(true);
        clear_supporter_intent();
        setSupporterToast("You're a Supporter - thank you! \ud83d\udc9c");
        let real2 = (jacIsLoggedIn() && (localStorage.getItem("libredraw:authMode") === "real"));
        if (!real2) {
          setAuthReason("supporter_save");
          setAuthOpen(true);
        }
      } else {
        setSupporterToast("Payment received - activating your Supporter perks. This can take a moment.");
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSupporterToast("Payment received - activating your Supporter perks. This can take a moment.");
      } else {
        throw __jac_e;
      }
    }
  }
  async function start_supporter_checkout() {
    if (isSupporter) {
      clear_supporter_intent();
      return;
    }
    if (supporterBusy) {
      return;
    }
    setSupporterBusy(true);
    try {
      let cfgres = await __jacSpawn("PaddleConfig", "", {});
      let cfg = (_jac.poly.and_(cfgres.reports, () => (cfgres.reports.length > 0)) ? cfgres.reports[0] : null);
      let subres = await __jacSpawn("MySubscription", "", {});
      let subrep = (_jac.poly.and_(subres.reports, () => (subres.reports.length > 0)) ? subres.reports[0] : null);
      if (((cfg === null) || !cfg["enabled"])) {
        setSupporterBusy(false);
        clear_supporter_intent();
        setNotice("Supporter membership is being set up - please check back soon. The whole editor stays free.");
        return;
      }
      let pid = ((supporterCycle === "annual") ? cfg["price_annual"] : cfg["price_monthly"]);
      let rjid = (((subrep !== null) && _jac.poly.contains(subrep, "root_jid")) ? subrep["root_jid"] : "");
      openSupporterCheckout({"clientToken": cfg["client_token"], "environment": cfg["environment"], "priceId": pid, "rootJid": rjid, "onCompleted": d => {
        on_checkout_completed(d);
      }, "onClose": () => {
        setSupporterBusy(false);
      }, "onError": m => {
        setSupporterBusy(false);
        setNotice("We couldn't start the checkout just now - please try again in a moment. If it keeps happening, the payment setup is still being finalised.");
      }});
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setSupporterBusy(false);
        setNotice("Couldn't open checkout - please try again.");
      } else {
        throw __jac_e;
      }
    }
  }
  async function open_portal() {
    try {
      let res = await __jacSpawn("CustomerPortal", "", {});
      let rep = (_jac.poly.and_(res.reports, () => (res.reports.length > 0)) ? res.reports[0] : null);
      let url = (((rep !== null) && _jac.poly.contains(rep, "url")) ? rep["url"] : "");
      if ((url !== "")) {
        window.open(url, "_blank");
      } else {
        setNotice("Couldn't open the subscription portal - please try again in a moment.");
      }
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setNotice("Couldn't open the subscription portal - please try again in a moment.");
      } else {
        throw __jac_e;
      }
    }
  }
  useEffect(() => {
    let lo = localStorage.getItem("libredraw:leftOpen");
    if ((lo !== null)) {
      setLeftOpen((lo === "1"));
    }
    let ro = localStorage.getItem("libredraw:rightOpen");
    if ((ro !== null)) {
      setRightOpen((ro === "1"));
    }
    let loggedIn = jacIsLoggedIn();
    let real = (loggedIn && (localStorage.getItem("libredraw:authMode") === "real"));
    setIsAuthed(real);
    setOpenTabs(load_open_tabs());
    ensure_backend(real);
    let sup = (_jac.poly.call(Reflect.construct(URLSearchParams, [location.search]), "get", "supporter") || "");
    if (((sup !== "monthly") && (sup !== "annual"))) {
      sup = (sessionStorage.getItem("libredraw:supporterIntent") || "");
    }
    if (((sup === "monthly") || (sup === "annual"))) {
      setSupporterCycle(sup);
      sessionStorage.setItem("libredraw:supporterIntent", sup);
      strip_query_param("supporter");
    }
    let justPaid = (sessionStorage.getItem("libredraw:supporterJustPaid") || "");
    if ((justPaid === "1")) {
      sessionStorage.removeItem("libredraw:supporterJustPaid");
      setSupporterCycle("");
      sessionStorage.removeItem("libredraw:supporterIntent");
      setSupporterToast("Payment received - activating your Supporter perks. This can take a moment.");
      check_supporter();
    } else if (real) {
      check_supporter();
    }
    window.addEventListener("keydown", e => {
      let tag = (e.target ? e.target.tagName : "");
      let typing = (((tag === "INPUT") || (tag === "TEXTAREA")) || (tag === "SELECT"));
      let mod = (e.metaKey || e.ctrlKey);
      let k = e.key;
      if ((mod && ((k === "k") || (k === "K")))) {
        e.preventDefault();
        setPaletteOpen(true);
      } else if ((mod && ((k === "f") || (k === "F")))) {
        e.preventDefault();
        setFindOpen(true);
      } else if ((!typing && !mod)) {
        if ((k === "Escape")) {
          setToolLocked(false);
          setActiveTool("select");
        } else if (((k === "v") || (k === "V"))) {
          setActiveTool("select");
        } else if (((k === "h") || (k === "H"))) {
          setActiveTool("pan");
        } else if (((k === "r") || (k === "R"))) {
          setDrawKind("rectangle");
          setActiveTool("shape");
        } else if (((k === "o") || (k === "O"))) {
          setDrawKind("ellipse");
          setActiveTool("shape");
        } else if (((k === "d") || (k === "D"))) {
          setDrawKind("diamond");
          setActiveTool("shape");
        } else if (((k === "p") || (k === "P"))) {
          setActiveTool("pen");
        } else if (((k === "t") || (k === "T"))) {
          setActiveTool("text");
        } else if (((k === "s") || (k === "S"))) {
          setActiveTool("sticky");
        } else if (((k === "c") || (k === "C"))) {
          setActiveTool("connector");
        } else if (((k === "m") || (k === "M"))) {
          setActiveTool("comment");
        } else if (((k === "e") || (k === "E"))) {
          setActiveTool("eraser");
        } else if (((k === "q") || (k === "Q"))) {
          setToolLocked(!toolLocked);
        }
      }
    });
  }, []);
  pageElementsRef.current = pageElements;
  activePageIdRef.current = activePageId;
  pageCommentsRef.current = pageComments;
  if (!legacyMirrorRef.current) {
    legacyMirrorRef.current = true;
    migrateLegacyMirror();
  }
  let root_cls = cn("flex h-screen flex-col bg-background text-foreground", "select-none [-webkit-touch-callout:none] [&_input]:select-text [&_textarea]:select-text", ((theme === "dark") ? "dark" : ""));
  let field_cls = cn("relative flex-1 overflow-hidden", (gridOn ? "canvas-field" : ""));
  let sel_id = ((selected !== null) ? selected["id"] : null);
  return __jacJsx("div", {"className": root_cls}, [__jacJsx(TopBar, {"onBack": onExit, "isAuthed": isAuthed, "onSignIn": _e => {
    setAuthOpen(true);
  }, "onLogout": _e => {
    localStorage.removeItem("libredraw:authMode");
    jacLogout();
    window.location.reload();
  }, "onCommand": name => {
    if ((name === "import")) {
      setImportOpen(true);
    } else {
      dispatch(name);
    }
  }, "onNewPage": _e => {
    add_page();
  }, "onInsert": k => {
    setDrawKind(k);
    setActiveTool("shape");
  }, "onOpenAI": _e => {
    setRightTab("ai");
    setRightOpen(true);
  }, "onOpenPalette": _e => {
    setPaletteOpen(true);
  }, "theme": theme, "onSetTheme": t => {
    setTheme(t);
  }, "onToggleGrid": _x => {
    setGridOn(!gridOn);
  }, "onShare": _e => {
    share_doc();
  }, "collabActive": (collabId !== ""), "publiclyShared": ((collabId !== "") && (shareAccess === "link")), "collabCount": collab_count(), "collaborators": peer_list(), "onOpenTrash": _e => {
    open_trash();
  }, "onHistory": _e => {
    open_history();
  }, "onDashboard": _e => {
    navigate("/dashboard");
  }, "onContribute": _e => {
    setContributeOpen(true);
  }, "isSupporter": isSupporter, "onManageSupporter": _e => {
    open_portal();
  }, "onShortcuts": _e => {
    setShortcutsOpen(true);
  }, "docName": diagramName, "folderPath": folderPath, "onOpenFolder": fid => {
    navigate(("/dashboard?folder=" + fid));
  }, "canRename": (!collabId || shareOwnerIsMe), "onRename": nm => {
    rename_doc(nm);
  }}, []), __jacJsx(DiagramTabs, {"tabs": openTabs, "activeId": diagramId, "onSwitch": did => {
    switch_diagram(did);
  }, "onClose": did => {
    close_tab(did);
  }}, []), ((((supporterCycle !== "") && !isSupporter) && !authOpen) ? __jacJsx("div", {"className": "fixed inset-0 z-[96] flex items-center justify-center bg-background/70 p-4"}, [__jacJsx("div", {"role": "dialog", "aria-modal": "true", "aria-labelledby": "finish-supporter-title", "className": "w-full max-w-md rounded-2xl border border-primary/40 bg-card p-6 shadow-pop"}, [__jacJsx("div", {"className": "flex items-start justify-between"}, [__jacJsx("div", {"className": "flex items-center gap-2"}, [__jacJsx("span", {"className": "flex size-9 items-center justify-center rounded-xl bg-primary-soft text-primary"}, [__jacJsx(Sparkles, {"size": 18}, [])]), __jacJsx("div", {}, [__jacJsx("h2", {"id": "finish-supporter-title", "className": "text-lg font-semibold tracking-tight"}, ["Finish becoming a Supporter"]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [((supporterCycle === "annual") ? "$24 / year - save 33% vs monthly" : "$3 / month")])])]), __jacJsx("button", {"onClick": _e => {
    clear_supporter_intent();
  }, "aria-label": "Not now", "className": "flex size-8 items-center justify-center rounded-lg text-muted-foreground outline-none hover:bg-accent hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary"}, [__jacJsx(X, {"size": 17}, [])])]), __jacJsx("p", {"className": "mt-4 text-sm text-muted-foreground"}, ["You're one step away. Complete secure checkout through Paddle to activate your Supporter membership - a supporter badge, priority support, and early access to new features. The whole editor stays free."]), __jacJsx("button", {"onClick": _e => {
    start_supporter_checkout();
  }, "disabled": supporterBusy, "className": "mt-5 flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground outline-none transition-colors hover:bg-primary/90 focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60"}, [__jacJsx(Sparkles, {"size": 15}, []), " ", (supporterBusy ? "Opening..." : "Complete checkout")]), __jacJsx("button", {"onClick": _e => {
    clear_supporter_intent();
  }, "className": "mt-2 w-full text-center text-[11px] text-muted-foreground hover:text-foreground"}, ["Not now - the core editor is always free"])])]) : null), ((supporterToast !== "") ? __jacJsx("div", {"className": "fixed left-1/2 top-14 z-[96] flex max-w-md -translate-x-1/2 items-center gap-2 rounded-xl border border-primary/40 bg-card px-4 py-2.5 text-sm shadow-pop"}, [__jacJsx(Heart, {"size": 16, "className": "shrink-0 text-primary"}, []), __jacJsx("span", {"className": "text-foreground"}, [supporterToast]), __jacJsx("button", {"onClick": _e => {
    setSupporterToast("");
  }, "title": "Dismiss", "className": "flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, ["✕"])]) : null), ((shareToast !== "") ? __jacJsx("div", {"className": "fixed left-1/2 top-14 z-50 flex -translate-x-1/2 items-center gap-2 rounded-xl border border-border bg-card px-3 py-2 text-sm shadow-pop"}, [__jacJsx("span", {"className": "flex size-5 items-center justify-center rounded-full bg-success/15 text-success"}, ["✓"]), __jacJsx("span", {"className": "text-foreground"}, [shareToast]), __jacJsx("input", {"readOnly": true, "value": shareLink, "onClick": e => {
    e.target.select();
  }, "className": "w-60 rounded-md border border-border bg-muted px-2 py-1 font-mono text-xs text-muted-foreground outline-none"}, []), __jacJsx("button", {"onClick": _e => {
    setShareToast("");
  }, "className": "flex size-6 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, ["✕"])]) : null), ((notice !== "") ? __jacJsx("div", {"role": "alert", "className": "fixed left-1/2 top-14 z-[95] flex max-w-md -translate-x-1/2 items-center gap-2 rounded-xl border border-destructive/30 bg-card px-4 py-2.5 text-sm shadow-pop"}, [__jacJsx("span", {"className": "flex size-5 shrink-0 items-center justify-center rounded-full bg-destructive/15 text-destructive"}, ["!"]), __jacJsx("span", {"className": "text-foreground"}, [notice]), __jacJsx("button", {"onClick": _e => {
    setNotice("");
  }, "title": "Dismiss", "className": "flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, ["✕"])]) : null), ((previewSnap !== "") ? __jacJsx("div", {"role": "alert", "data-testid": "preview-banner", "className": "fixed left-1/2 top-14 z-[95] flex -translate-x-1/2 items-center gap-3 rounded-xl border border-primary/40 bg-card px-4 py-2 text-sm shadow-pop"}, [__jacJsx("span", {"className": "font-medium text-foreground"}, ["Previewing an earlier version"]), __jacJsx("button", {"data-testid": "restore-version", "onClick": _e => {
    restore_snapshot(previewSnap);
  }, "className": "rounded-lg bg-primary px-3 py-1.5 text-xs font-medium text-primary-foreground hover:bg-primary/90"}, ["Restore this version"]), __jacJsx("button", {"onClick": _e => {
    exit_preview();
  }, "className": "rounded-lg border border-border px-3 py-1.5 text-xs font-medium hover:bg-accent"}, ["Exit preview"])]) : null), __jacJsx("div", {"className": "relative flex min-h-0 flex-1"}, [(leftOpen ? __jacJsx("div", {"className": "relative shrink-0", "style": {"width": (String(leftWidth) + "px")}}, [__jacJsx(LeftPanel, {"onCollapse": _e => {
    set_left(false);
  }, "onPick": k => {
    setDrawKind(k);
    setActiveTool("shape");
  }, "onInsertStencil": st => {
    insert_stencil(st);
  }, "userLibraries": userLibraries, "hasSelection": (selected !== null), "onSaveSelection": _e => {
    save_selection_stencil();
  }, "onAddLibrary": data => {
    add_library(data["name"], data["stencils"]);
  }, "onDeleteLibrary": lid => {
    delete_library(lid);
  }}, []), __jacJsx("div", {"title": "Drag to resize", "onMouseDown": e => {
    setDragging("left");
    setDragStartX(Math.trunc(Number(e.clientX)));
    setDragStartW(leftWidth);
  }, "className": "group absolute -right-1 top-0 z-10 h-full w-2 cursor-col-resize"}, [__jacJsx("div", {"className": "mx-auto h-full w-px bg-transparent transition-colors group-hover:bg-primary"}, [])])]) : __jacJsx("button", {"title": "Show shapes panel", "onClick": _e => {
    set_left(true);
  }, "className": "absolute left-3 top-3 z-30 flex size-8 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground shadow-sm hover:bg-accent hover:text-foreground"}, [__jacJsx(PanelLeftOpen, {"size": 16}, [])])), __jacJsx("div", {"className": field_cls}, [__jacJsx(ToolRail, {"activeTool": activeTool, "onSelect": t => {
    if ((t === "select")) {
      setToolLocked(false);
    }
    setActiveTool(t);
  }, "toolLocked": toolLocked, "onToggleLock": _e => {
    setToolLocked(!toolLocked);
  }, "onAskAI": _e => {
    setRightTab("ai");
    setRightOpen(true);
  }}, []), __jacJsx(CanvasStage, {"key": activePageId, "pageId": activePageId, "initialElements": cur_elements(), "activeTool": activeTool, "drawKind": drawKind, "onToolConsumed": _e => {
    if (!toolLocked) {
      setActiveTool("select");
    }
  }, "onSelect": el => {
    setSelected(el);
    if (((el !== null) && (el["kind"] === "connector"))) {
      setRightTab("properties");
      setRightOpen(true);
    }
  }, "styleReq": {"n": styleN, "patch": stylePatch}, "selectReq": {"n": selectN, "id": selectId}, "commandReq": {"n": commandN, "name": commandName, "arg": commandArg}, "insertReq": {"n": insertN, "stencil": insertStencil}, "onPersist": persist, "comments": cur_comments(), "activeCommentId": activeCommentId, "onPlaceComment": (x, y) => {
    if (can_comment()) {
      place_comment(x, y);
    }
  }, "onOpenComment": id => {
    open_comment(id);
  }, "syncReq": {"n": collabSyncN, "elements": collabSyncEls, "pageId": collabSyncPageId}, "onLocalChange": els => {
    if (((collabId && can_edit()) && page_in_share(activePageId))) {
      broadcast_doc(activePageId, els);
    }
  }, "onCursor": (x, y) => {
    if ((collabId && page_in_share(activePageId))) {
      broadcast_cursor(x, y);
    }
  }, "remoteCursors": remote_cursor_list(), "editable": can_edit(), "docName": diagramName, "docId": diagram_param(), "onImport": _e => {
    setImportOpen(true);
  }, "onTemplate": _e => {
    setTemplateOpen(true);
  }}, [])]), (rightOpen ? __jacJsx("div", {"className": "relative shrink-0", "style": {"width": (String(rightWidth) + "px")}}, [__jacJsx("div", {"title": "Drag to resize", "onMouseDown": e => {
    setDragging("right");
    setDragStartX(Math.trunc(Number(e.clientX)));
    setDragStartW(rightWidth);
  }, "className": "group absolute -left-1 top-0 z-10 h-full w-2 cursor-col-resize"}, [__jacJsx("div", {"className": "mx-auto h-full w-px bg-transparent transition-colors group-hover:bg-primary"}, [])]), __jacJsx(RightPanel, {"panelWidth": rightWidth, "activeTab": rightTab, "theme": theme, "gridOn": gridOn, "onTab": t => {
    setRightTab(t);
  }, "onSetTheme": t => {
    setTheme(t);
  }, "onToggleGrid": _x => {
    setGridOn(!gridOn);
  }, "onCollapse": _e => {
    set_right(false);
  }, "selected": selected, "onStyle": p => {
    setStylePatch(p);
    setStyleN((styleN + 1));
  }, "elements": cur_elements(), "selectedId": sel_id, "onSelectLayer": id => {
    select_layer(id);
  }, "onDeleteLayer": id => {
    dispatch_arg("deleteId", id);
  }, "pageName": page_name(activePageId), "onRenamePage": nm => {
    rename_page(activePageId, nm);
  }, "onExport": _e => {
    dispatch("exportPng");
  }, "comments": cur_comments(), "activeCommentId": activeCommentId, "onOpenComment": id => {
    open_comment(id);
  }, "onReply": (cid, text) => {
    if (can_comment()) {
      add_reply(cid, text);
    }
  }, "onResolve": id => {
    if (can_comment()) {
      resolve_comment(id);
    }
  }, "onDeleteComment": id => {
    if (can_edit()) {
      delete_comment(id);
    }
  }, "onStartComment": _e => {
    setActiveTool("comment");
  }, "onSharePage": _e => {
    share_doc();
  }, "pageShared": page_is_shared(), "pageAccessLabel": page_access_label(), "selectedIds": sel_ids(), "onSelectGroup": gid => {
    dispatch_arg("selectGroup", gid);
  }, "onRenameGroup": (gid, name) => {
    dispatch_arg("renameGroup", {"gid": gid, "name": name});
  }, "onDeleteGroup": gid => {
    dispatch_arg("deleteGroup", gid);
  }, "editable": can_edit(), "onShowConnected": id => {
    show_connected(id);
  }, "onArrange": op => {
    dispatch_arg("align", op);
  }, "onOrder": op => {
    dispatch(op);
  }, "onToggleLock": id => {
    (id ? dispatch_arg("toggleLock", id) : dispatch("toggleLock"));
  }, "onToggleHide": id => {
    (id ? dispatch_arg("toggleHide", id) : dispatch("toggleHide"));
  }}, [])]) : __jacJsx("button", {"title": "Show properties panel", "onClick": _e => {
    set_right(true);
  }, "className": "absolute right-3 top-3 z-30 flex size-8 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground shadow-sm hover:bg-accent hover:text-foreground"}, [__jacJsx(PanelRightOpen, {"size": 16}, [])]))]), __jacJsx(PageBar, {"pages": pages, "activePageId": activePageId, "onSwitch": pid => {
    switch_page(pid);
  }, "onAdd": _e => {
    add_page();
  }, "onRename": (pid, nm) => {
    rename_page(pid, nm);
  }, "onDuplicate": pid => {
    duplicate_page(pid);
  }, "onDelete": pid => {
    ask_delete_page(pid);
  }, "onReorder": order => {
    reorder_pages(order);
  }, "onUndo": _e => {
    dispatch("undo");
  }, "onRedo": _e => {
    dispatch("redo");
  }, "onShortcuts": _e => {
    setShortcutsOpen(true);
  }}, []), (authOpen ? __jacJsx(AuthModal, {"isGuest": (backendReady && !isAuthed), "reason": authReason, "onClose": _e => {
    setAuthOpen(false);
    setAuthReason("");
  }, "onAuthed": _x => {
    localStorage.setItem("libredraw:authMode", "real");
    localStorage.removeItem("libredraw:guest");
    setIsAuthed(true);
    setBackendReady(true);
    setAuthOpen(false);
    let r = authReason;
    setAuthReason("");
    hydrate();
    if (((r !== "supporter_save") && (supporterCycle !== ""))) {
      start_supporter_checkout();
    }
  }}, []) : null), (paletteOpen ? __jacJsx(CommandPalette, {"activeTool": activeTool, "onClose": _e => {
    setPaletteOpen(false);
  }, "onCommand": name => {
    if ((name === "import")) {
      setImportOpen(true);
    } else if ((name === "find")) {
      setFindOpen(true);
    } else if ((name === "template")) {
      setTemplateOpen(true);
    } else {
      dispatch(name);
    }
    setPaletteOpen(false);
  }, "onTool": t => {
    setActiveTool(t);
    setPaletteOpen(false);
  }, "onInsert": k => {
    setDrawKind(k);
    setActiveTool("shape");
    setPaletteOpen(false);
  }, "onNewPage": _e => {
    add_page();
    setPaletteOpen(false);
  }, "onToggleTheme": _e => {
    setTheme(((theme === "light") ? "dark" : "light"));
    setPaletteOpen(false);
  }}, []) : null), (trashOpen ? __jacJsx("div", {"className": "fixed inset-0 z-[60] flex items-start justify-center bg-black/30 pt-[12vh] backdrop-blur-sm", "onMouseDown": _e => {
    setTrashOpen(false);
  }}, [__jacJsx("div", {"className": "w-[520px] max-w-[92vw] overflow-hidden rounded-2xl border border-border bg-card shadow-pop", "onMouseDown": e => {
    e.stopPropagation();
  }}, [__jacJsx("div", {"className": "flex items-center justify-between border-b border-border px-4 py-3"}, [__jacJsx("div", {"className": "flex items-center gap-2"}, [__jacJsx("span", {"className": "text-sm font-semibold"}, ["Deleted pages"]), __jacJsx("span", {"className": "rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground"}, [String(trashList.length)])]), __jacJsx("button", {"onClick": _e => {
    setTrashOpen(false);
  }, "className": "flex size-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, ["✕"])]), __jacJsx("div", {"className": "scroll-thin max-h-[52vh] overflow-y-auto p-2"}, [((trashList.length === 0) ? __jacJsx("div", {"className": "flex flex-col items-center justify-center gap-2 py-14 text-center"}, [__jacJsx("div", {"className": "flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground"}, [__jacJsx(Trash2, {"size": 18}, [])]), __jacJsx("p", {"className": "text-sm font-medium"}, ["Trash is empty"]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["Deleted pages appear here and are kept for 30 days."])]) : __jacJsx("div", {"className": "flex flex-col gap-1"}, [trashList.map(t => __jacJsx("div", {"key": t["id"], "className": "flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-accent"}, [__jacJsx("span", {"className": "flex size-8 shrink-0 items-center justify-center rounded-md bg-muted text-muted-foreground"}, [__jacJsx(FileText, {"size": 15}, [])]), __jacJsx("div", {"className": "min-w-0 flex-1"}, [__jacJsx("div", {"className": "truncate text-sm text-foreground"}, [t["name"]]), __jacJsx("div", {"className": "text-xs text-muted-foreground"}, [(((String(t["count"]) + ((t["count"] === 1) ? " item" : " items")) + " \u00b7 deleted ") + t["trashed_at"].slice(0, 10))])]), __jacJsx("button", {"onClick": _e => {
    restore_page(t["id"]);
  }, "className": "rounded-md border border-border px-2.5 py-1 text-xs font-medium text-foreground hover:bg-primary-soft hover:text-primary"}, ["Restore"]), __jacJsx("button", {"title": "Delete forever", "onClick": _e => {
    purge_page(t["id"]);
  }, "className": "flex size-7 items-center justify-center rounded-md text-muted-foreground hover:bg-destructive/10 hover:text-destructive"}, [__jacJsx(Trash2, {"size": 14}, [])])]))]))]), __jacJsx("div", {"className": "border-t border-border px-4 py-2 text-xs text-muted-foreground"}, ["Deleted pages are kept for 30 days, then permanently removed."])])]) : null), ((pageConfirmDelete !== "") ? __jacJsx("div", {"className": "fixed inset-0 z-[75] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm", "onMouseDown": _e => {
    setPageConfirmDelete("");
  }}, [__jacJsx("div", {"role": "dialog", "aria-modal": "true", "aria-label": "Delete page", "className": "w-[440px] max-w-[92vw] overflow-hidden rounded-2xl border border-border bg-card p-5 shadow-pop", "onMouseDown": e => {
    e.stopPropagation();
  }}, [__jacJsx("h2", {"className": "text-base font-semibold text-foreground"}, ["Delete '", page_name(pageConfirmDelete), "'?"]), __jacJsx("p", {"className": "mt-1.5 text-sm text-muted-foreground"}, ["This page has ", String(page_el_count(pageConfirmDelete)), " ", ((page_el_count(pageConfirmDelete) === 1) ? "object" : "objects"), ". You can restore it from ", __jacJsx("span", {"className": "font-medium text-foreground"}, ["File → Deleted pages"]), " for 30 days."]), __jacJsx("div", {"className": "mt-4 flex justify-end gap-2"}, [__jacJsx("button", {"onClick": _e => {
    setPageConfirmDelete("");
  }, "className": "rounded-lg border border-border px-3.5 py-2 text-sm font-medium hover:bg-accent"}, ["Cancel"]), __jacJsx("button", {"data-testid": "confirm-delete-page", "onClick": _e => {
    delete_page(pageConfirmDelete);
  }, "className": "rounded-lg bg-destructive px-3.5 py-2 text-sm font-medium text-destructive-foreground hover:bg-destructive/90"}, ["Delete page"])])])]) : null), (historyOpen ? __jacJsx("div", {"className": "fixed inset-0 z-[70] flex items-start justify-center bg-black/40 pt-[10vh] backdrop-blur-sm", "onMouseDown": _e => {
    setHistoryOpen(false);
  }}, [__jacJsx("div", {"role": "dialog", "aria-modal": "true", "aria-label": "Version history", "className": "flex max-h-[70vh] w-[460px] max-w-[92vw] flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-pop", "onMouseDown": e => {
    e.stopPropagation();
  }}, [__jacJsx("div", {"className": "flex items-center justify-between border-b border-border px-5 py-3"}, [__jacJsx("span", {"className": "text-sm font-semibold"}, ["Version history"]), __jacJsx("button", {"onClick": _e => {
    setHistoryOpen(false);
  }, "className": "flex size-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, ["✕"])]), __jacJsx("div", {"className": "scroll-thin flex-1 overflow-y-auto p-2"}, [((historyList.length === 0) ? __jacJsx("div", {"className": "flex flex-col items-center justify-center gap-2 py-14 text-center"}, [__jacJsx("div", {"className": "flex size-10 items-center justify-center rounded-full bg-muted text-muted-foreground"}, ["↺"]), __jacJsx("p", {"className": "text-sm font-medium"}, ["No versions yet"]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["Versions are captured automatically as you edit, and kept for up to 30 versions."])]) : __jacJsx("div", {"className": "flex flex-col"}, [historyList.map(h => __jacJsx("button", {"key": h["id"], "data-testid": "version-entry", "aria-label": ("Preview version from " + snap_rel(String(h["created_at"]))), "onClick": _e => {
    preview_snapshot(String(h["id"]));
  }, "className": "flex items-center justify-between gap-3 rounded-lg px-3 py-2.5 text-left hover:bg-accent"}, [__jacJsx("div", {"className": "min-w-0"}, [__jacJsx("div", {"className": "text-sm font-medium text-foreground"}, [snap_rel(String(h["created_at"]))]), __jacJsx("div", {"className": "text-xs text-muted-foreground"}, [(String(h["page_count"]) + ((Math.trunc(Number(h["page_count"])) === 1) ? " page" : " pages"))])]), __jacJsx("span", {"className": "shrink-0 text-xs font-medium text-primary"}, ["Preview"])]))]))]), __jacJsx("div", {"className": "border-t border-border px-5 py-2 text-xs text-muted-foreground"}, ["A snapshot is taken while you edit (at most one every few minutes) and before any restore, so a restore can be undone. Kept up to 30 versions."])])]) : null), (contributeOpen ? __jacJsx(ContributeModal, {"onClose": () => {
    setContributeOpen(false);
  }}, []) : null), (shortcutsOpen ? __jacJsx(ShortcutsModal, {"onClose": () => {
    setShortcutsOpen(false);
  }}, []) : null), (importOpen ? __jacJsx(ImportModal, {"onClose": () => {
    setImportOpen(false);
  }, "onImport": els => {
    insert_stencil({"elements": els, "group": false, "name": "Imported"});
  }}, []) : null), (findOpen ? __jacJsx(FindPanel, {"pages": pages, "pageElements": pageElements, "onJump": (pid, eid) => {
    switch_page(pid);
    select_layer(eid);
  }, "onClose": _e => {
    setFindOpen(false);
  }}, []) : null), (templateOpen ? __jacJsx(TemplatePicker, {"onPick": els => {
    insert_stencil({"elements": els, "group": false, "name": "Template"});
  }, "onClose": _e => {
    setTemplateOpen(false);
  }}, []) : null), (shareDialogOpen ? __jacJsx(ShareDialog, {"onClose": _e => {
    setShareDialogOpen(false);
  }, "title": shareTitle, "shareLink": shareLink, "access": shareAccess, "linkRole": shareLinkRole, "people": sharePeople, "isOwner": shareOwnerIsMe, "myRole": myRole, "isShared": (collabId !== ""), "onSetAccess": a => {
    set_access_mode(a);
  }, "onSetLinkRole": r => {
    set_link_role(r);
  }, "onAddPerson": (em, r) => {
    add_person(em, r);
  }, "onSetPersonRole": (em, r) => {
    set_person_role(em, r);
  }, "onRemovePerson": em => {
    remove_person(em);
  }, "onCopyLink": _e => {
    copy_share_link();
  }, "onStopSharing": _e => {
    stop_sharing();
  }}, []) : null), (shareDenied ? __jacJsx("div", {"className": "fixed inset-0 z-[80] flex items-center justify-center bg-background"}, [__jacJsx("div", {"className": "flex max-w-sm flex-col items-center gap-3 text-center"}, [__jacJsx("div", {"className": "flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground"}, [__jacJsx(PanelRightOpen, {"size": 22}, [])]), __jacJsx("h2", {"className": "text-lg font-semibold"}, ["You need access"]), __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["This diagram is restricted. Ask the owner to invite your email, or sign in with an account that has access."]), __jacJsx("div", {"className": "mt-1 flex gap-2"}, [__jacJsx("button", {"onClick": _e => {
    setAuthOpen(true);
  }, "className": "rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"}, ["Sign in"]), __jacJsx("button", {"onClick": _e => {
    window.location.href = (window.location.origin + window.location.pathname);
  }, "className": "rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-accent"}, ["Go to my diagrams"])])])]) : null), (diagramNotFound ? __jacJsx("div", {"className": "fixed inset-0 z-[80] flex items-center justify-center bg-background"}, [__jacJsx("div", {"className": "flex max-w-sm flex-col items-center gap-3 text-center"}, [__jacJsx("div", {"className": "flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground"}, [__jacJsx(FileText, {"size": 22}, [])]), __jacJsx("h2", {"className": "text-lg font-semibold"}, ["Diagram not found"]), __jacJsx("p", {"className": "text-sm text-muted-foreground"}, ["This diagram doesn't exist or isn't available on this device. The link may be out of date."]), __jacJsx("div", {"className": "mt-1 flex gap-2"}, [__jacJsx("button", {"onClick": _e => {
    navigate("/dashboard");
  }, "className": "rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"}, ["Go to my diagrams"]), __jacJsx("button", {"onClick": _e => {
    navigate("/canvas");
  }, "className": "rounded-lg border border-border px-4 py-2 text-sm font-medium hover:bg-accent"}, ["New diagram"])])])]) : null), (dragging ? __jacJsx("div", {"className": "fixed inset-0 z-50 cursor-col-resize", "onMouseMove": e => {
    let dx = (Math.trunc(Number(e.clientX)) - dragStartX);
    if ((dragging === "left")) {
      setLeftWidth(Math.trunc(Number(Math.max(188, Math.min(480, (dragStartW + dx))))));
    } else if ((dragging === "right")) {
      setRightWidth(Math.trunc(Number(Math.max(212, Math.min(520, (dragStartW - dx))))));
    }
  }, "onMouseUp": _e => {
    setDragging("");
  }, "onMouseLeave": _e => {
    setDragging("");
  }}, []) : null)]);
}
/*jac:refresh-boundary*/;
export {EditorShell};
//# sourceMappingURL=EditorShell.js.map
